/* eslint-disable import/order */
import { isClonedVoiceCode } from '@vbee-holding/aivoice-shared-lib';
import React, { useState, useEffect, useRef, createRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useHistory, useLocation as useLocationRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import camelcaseKeys from 'camelcase-keys';
import LockCycle from '@src/assets/images/lock-cycle.svg';
import { EditorState, ContentState, CompositeDecorator } from 'draft-js';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useGrowthBook } from '@growthbook/growthbook-react';
import sanitizeHtml from 'sanitize-html';

import {
  LANGUAGE_CODE,
  REQUEST_STATUS,
  MAX_TRY_LISTENING_CHARACTERS,
  BREAK_TIME_REGEX,
  REGEX,
  ENGLISH_VOICE_CODES,
  VOICE_PROVIDER,
  BITRATE,
  VOICE_OWNERSHIP,
  OUTPUT_AUDIO,
  COMMUNITY_VOICE,
  VOICE_CODE,
  SHOW_VOICES,
  DEFAULT_SYNTHESIS_REQUEST,
} from '@src/constants/voice';
import { WS_TYPE, PING_INTERVAL } from '@src/constants/websocket';
import {
  LANDING_PAGE_URL,
  RECAPTCHA_ENTERPRISE_SITE_KEY,
  TTS_SYNTHESIS_URL,
} from '@src/configs';
import {
  countTextLength,
  checkValidXml,
  checkFeaturePermission,
  countCreditsSynthesis,
  // countCreditsOfSentences,
  countTextLengthOfSentences,
} from '@src/services/tts';
import CrownImg from '@src/assets/images/crown.png';
import {
  newSplitParagraphIntoSentence,
  splitParagraphIntoSentence,
  getSentencesPayload,
  newGetSentencesPayload,
  convertSentenceToParagraphs,
} from '@src/services/sentence';
import { findWithRegexEditor, generateDecorator } from '@src/services/editor';
import { deleteDataLocalStorage } from '@src/utils/localStorage';
import {
  convertParagraphsToText,
  checkSyntaxTagsParagraphs,
  convertTextToParagraphs,
  countCreditEditorStateLength,
  countEditorStateLength,
} from '@src/services/paragraph';

import Card from '@src/components/Card';
import {
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { FEATURE_KEYS } from '@src/configs/featureKeys';

// import arrowIconDown from '@src/assets/icons/arrow-icon-down.png';
import ConfirmDialog from '@src/components/Dialog/ConfirmDialog';
import apis from '@src/apis';
import actions from '@src/redux/actions';
import ROUTES from '@src/constants/route';

import { checkVietNam } from '@src/utils/checkCountry';
import NotificationDialog from '@src/components/NotificationDialog';
import {
  CAPTCHA_PROVIDER,
  DIALOG_V2_TYPE,
  MOBILE_BREAKPOINT,
  POPUP_TIME_OUT,
  ZERO_BREAK_TIME_REGEX,
  MAX_AUDIO_RETENTION_PERIOD,
} from '@src/constants';
import Decorator from '@src/components/Decorator';
import {
  STEPS_ENTER_TEXT_HERE_GUIDE,
  STEPS_TTS_GUIDE,
} from '@src/constants/tourGuide';
import {
  checkSyntaxTagsElements,
  convertElementsToText,
  getEntityStrategy,
} from '@src/services/entity';
import {
  VALID_SPEED,
  TTS_VERSION,
  VALID_CHARACTERS_LENGTH_REGEX,
  VALID_CHARACTERS_REGEX,
  PLAYING_AUDIO_TYPE,
  VOICE_VERSION,
  VALID_LETTERS,
  VALID_CHARACTERS_REGEX_SAFARI,
} from '@src/constants/tts';
import { ERROR_CODE } from '@src/errors/code';
import {
  FEATURE,
  FREE_PACKAGE_CODES,
  LIMITED_PREVIEW_PACKAGE_LEVEL,
  PACKAGE_CODE,
  PACKAGE_LEVEL,
  PACKAGE_LEVEL_V3,
  PACKAGE_STUDIO_VERSION,
} from '@src/constants/package';
import { RECAPTCHA_ACTION, RECAPTCHA_TYPE } from '@src/constants/recaptcha';
import { WARNING_REQUEST_TYPE } from '@src/constants/request';
import TrialPreviewImage from '@src/assets/icons/icon-preview.png';
import UpgradeImg from '@src/assets/images/space-shuttle.png';
import HightLightSpan from '@src/components/Decorator/HightLightSpan';
import ActionDialog from '@src/components/Dialog/ActionDialog';
import TurnstileWidget from '@src/components/TurnstileWidget';
import { BANNER_TYPE } from '@src/constants/banner';
import { isSameToday } from '@src/utils/time';
import useElementHeight from '@src/hooks/useElementHeight';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import useCustomKeycloak from '@src/hooks/useCustomKeycloak';
import useCustomerSupportView from '@src/hooks/useCustomerSupportView';

import BreakTimeHighlight from '../TTS/BreakTimeHightLight';
import BlackWordHighLight from '../TTS/BlackWordHighLight';
import { StyledTTS } from './index.style';
import TitleBar from './TitleBar';
import Content from './Content';
import NewRequest from './NewRequest';
import AudioPlayer from '../AudioPlayer';
import NewTourGuide from '../NewTourGuide';
import NotificationDialogV4 from '@src/components/NotificationDialogV4';
import {
  VOICE_STATUS,
  SUB_STATUS,
  VOICE_CLONE_TYPE,
} from '@src/constants/voiceCloning';
import { containsBlacklistedWords } from '@src/services/blackword';
import { registerRequestMeta, trackEvent } from '@src/services/moengage';
import { trackTryVoice, TRY_VOICE_ACTION } from '@src/services/voiceTracking';
import {
  MOE_LOCKED_WALLET,
  MOE_MODULE,
  MOE_EVENTS,
  MOE_PAYWALL_TRIGGER,
  MOE_PAYWALL_TYPE,
} from '@src/constants/moengage';
import usePaywallTracking from '@src/hooks/usePaywallTracking';
import NotificationDialogV3 from '@src/components/NotificationDialogV3';
import { checkBrowser } from '@src/utils/browser';
import { validateUserPackageCanUseVoiceCloning } from '@src/services/voiceCloning';
import {
  checkCustomPackage,
  checkFreePackage,
  checkShouldNotifyLowCredits,
} from '@src/services/package';
import useUserInfo from '@src/hooks/useTtsUser';
import TitleBarNew from './TitileBarNew';
import OutOfCreditsFree from './OutOfCreditsAlert/OutOfCreditsFree';
import OutOfCreditsSpecial from './OutOfCreditsAlert/OutOfCreditsSpecial';
import OutOfCreditsStandard from './OutOfCreditsAlert/OutOfCreditsStandard';
import FreeMaxCharsLimitExceeded from './MaxCharsLimitExceeded/FreeMaxCharsLimitExceeded';
import PaidMaxCharsLimitExceeded from './MaxCharsLimitExceeded/PaidMaxCharsLimitExceeded';
import ExpiredPackageAlert from './ExpiredPackageAlert';
import { useCanUseEOLVoice } from '@src/hooks/useCanUseEOLVoice';
import {
  isVoiceEligibleForTrial,
  willExceedTrialLimit,
  buildUpdatedTrialUsage,
  calculateVoiceCreditsMap,
  findExceededTrialVoices,
  isUsingTrialVoice,
} from '@src/services/voiceTrial';
import OutOfCreditsVip from './OutOfCreditsAlert/OutOfCreditsVip';
import OutOfCreditsCustom from './OutOfCreditsAlert/OutOfCreditsCustom';
import useLocation from '@src/hooks/useLocation';
import { INIT_NOTIFICATION_DIALOG } from '@src/constants/dialog';
import AILoadingOverlay from '@src/new-components/AILoadingOverlay';
import ToolbarV3 from './ToolbarV3';
import VoiceSelectionDialog from '../VoiceSelectionDialog';
import { shouldShowWeeklyHighlights } from '@src/services/leaderboard';
import CommonButton from '@src/new-components/Button';
import { COLOR } from '@src/styles/color';
import NotifyLowCredits from './NotifyLowCredits';
import useTotalCredits from '@src/hooks/useTotalCredits';
import {
  getTTSTourGuideValue,
  setTTSTourGuideValue,
} from '@src/utils/tourGuide';
import {
  formatNameForEOL,
  getUpgradePackageLabelKey,
} from '@src/services/voice';
import { PronunciationCheckContext } from '@src/contexts/PronunciationCheckContext';
import usePronunciationCheck from '@src/hooks/usePronunciationCheck';
import {
  HighlightWord,
  FixedWord,
  highlightStrategy,
  fixedWordStrategy,
} from './PronunciationDecorators';
import { getNswPayloadFromContent } from '@src/services/pronunciationCheck';
import NavigationBlocker from '@src/new-components/NavigationBlocker';

// import Requests from '../TTS/Requests';
// import SwitchAdvanceFeature from './SwitchAdvanceFeature';

const HEIGHT_LARGE_SCREEN = 900;
const OTHER_ELEMENT_HEIGHT = 175;
// const WIDTH_SCREEN_SHOW_MORE_BTN = 1395;

const TTSNew = ({ isNewHomepage, onClickAddRequest }) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { keycloak } = useCustomKeycloak();
  const audioRef = createRef();
  const growthbook = useGrowthBook();
  const { ip } = useLocation();

  const user = useSelector((state) => state.auth.user);
  const { usingPackage, trialVoiceUsage: stateTrialVoiceUsage } = useSelector(
    (state) => state.user,
  );
  const allPackages = useSelector((state) => state.packages.packages);
  const packageCode = usingPackage?.code;

  const { trackHit: trackTtsPaywall } = usePaywallTracking({
    module: MOE_MODULE.TTS,
    trigger: MOE_PAYWALL_TRIGGER.CONVERT,
  });

  const { ttsUser } = useUserInfo();
  const { totalCredits } = useTotalCredits();
  const { getFeatureValue } = useFeatureFlags();

  const userVoiceEolEnabled = getFeatureValue(FEATURE_KEYS.USER_VOICE_EOL, {
    userId: user.id,
  });

  const isUseStreamingPreview = getFeatureValue(
    FEATURE_KEYS.STREAMING_PREVIEW,
    {
      userId: user.id,
      email: user.email,
      phoneNumber: user.phoneNumber,
    },
  );

  const isSynthesisVoiceCloning = getFeatureValue(FEATURE_KEYS.VOICE_CLONING, {
    userId: user?.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });

  const voiceTrialConfig = getFeatureValue(FEATURE_KEYS.TRIAL_VOICE_CONFIG, {
    userId: user.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
    packageCode: user.packageCode,
  });
  const enableVoiceTrial = Boolean(voiceTrialConfig);
  const voiceHasBeenRenamed = getFeatureValue(
    FEATURE_KEYS.VOICE_HAS_BEEN_RENAMED,
    { userId: user.id, email: user.email, phoneNumber: user.phoneNumber, ip },
  );

  const captchaProvider = getFeatureValue(
    FEATURE_KEYS.CAPTCHA_PROVIDER_AIVOICE,
    { userId: user.id, email: user.email },
  );

  const cloudflareTurnstileEnabled = getFeatureValue(
    FEATURE_KEYS.CLOUDFLARE_TURNSTILE_AIVOICE,
    { userId: user.id, email: user.email },
  );

  const aiPronunciationCheckEnabled = getFeatureValue(
    FEATURE_KEYS.AI_PRONUNCIATION_CHECK,
    {
      userId: user?.id,
      email: user?.email,
      phoneNumber: user?.phoneNumber,
    },
  );

  const ttsRef = useRef();
  const requestTableRef = useRef();
  const requestTableHeight =
    useElementHeight(requestTableRef) + OTHER_ELEMENT_HEIGHT;
  const [synthesisSentence, setSynthesisSentence] = useState('');
  const [openVoices, setOpenVoices] = useState(false);
  const [content, setContent] = useState(
    EditorState.createEmpty(
      generateDecorator(BREAK_TIME_REGEX, BreakTimeHighlight),
    ),
  );
  // const [voice, setVoice] = useState();
  const [stepsGuide, setStepsGuide] = useState(STEPS_TTS_GUIDE);
  const [runTourGuide, setRunTourGuide] = useState(false);
  const [inputLength, setInputLength] = useState(0);
  // const [openRequest, setOpenRequest] = useState(false);
  const [characterExceed, setCharacterExceed] = useState(false);

  const [confirmSwitchParagraph, setConfirmSwitchParagraph] = useState(false);
  const [isSSML, setIsSSML] = useState(false);
  const [openSSMLDialog, setOpenSSMLDialog] = useState(false);
  const [openWrongBreakTimeDialog, setOpenWrongBreakTimeDialog] =
    useState(false);
  const [openDialogLockedCycle, setOpenDialogLockedCycle] = useState(null);
  // TODO: change state name => openWarningDialog
  const [openWrongSyntaxDialog, setOpenWrongSyntaxDialog] = useState(null);
  const [openWrongSyntaxDialogV2, setOpenWrongSyntaxDialogV2] = useState(null);
  const [triggerBtn, setTriggerBtn] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const [openDraft, setOpenDraft] = useState(false);
  const [loadDraft, setLoadDraft] = useState(false);

  const [flickerBackground, setFlickerBackground] = useState(false);
  const currentBrowser = checkBrowser();
  const [previewPayload, setPreviewPayload] = useState({});

  const [openMaxCharsLimitExceeded, setOpenMaxCharsLimitExceeded] =
    useState(false);
  const [actionDialog, setActionDialog] = useState();
  const [remainingPreview, setRemainingPreview] = useState(null);
  const [usedFreePreviews, setUsedFreePreviews] = useState(0);

  const [blackWords, setBlackWords] = useState([]);
  const [isExpandRequest, setIsExpandRequest] = useState();
  const [enableEditor, setEnableEditor] = useState(true);
  const [charsFactorCheckbox, setCharsFactorCheckbox] = useState(false);
  const [openOutOfCreditsDialog, setOpenOutOfCreditsDialog] = useState(false);
  const [openExpiredPackageDialog, setOpenExpiredPackageDialog] =
    useState(false);

  const [warningOneTimeCredits, setWarningOneTimeCredits] = useState(false);

  const [notifyLowCreditsDialog, setNotifyLowCreditsDialog] = useState(false);

  const turnstileWidgetRef = useRef(null);
  const turnstileWidgetForDemoRequestRef = useRef(null);

  const screenHeight = window.innerHeight;
  // const screenWidth = window.innerWidth;

  const runStreamAudioRef = useRef(false);

  const {
    isPlaying,
    requestPreviewId,
    audioType: playAudioType,
    isRunStreamAudio,
    showAudioPlayer,
  } = useSelector((state) => state.audioPlayer);
  const {
    synthesisRequest,
    paragraphs,
    sentences,
    openSentences,
    advanceFeature,
    voice,
    selectedSentences,
    loadingLoadRequest,
  } = useSelector((state) => state.synthesisRequest);
  const requestOutcome = useSelector((state) =>
    synthesisRequest?.id ? state.request[synthesisRequest.id] : undefined,
  );

  const { seenAllBanner } = useSelector((state) => state.banner);
  const {
    user: {
      remainingCharacters,
      bonusCharacters,
      packageExpiryDate,
      hasAgreedToTerms,
    },
  } = useSelector((state) => state.auth);

  const isUsingTurnstile =
    captchaProvider === CAPTCHA_PROVIDER.TURNSTILE &&
    cloudflareTurnstileEnabled;

  const { studio } = ttsUser;
  const { cycle, topUp, custom } = studio || {};
  let {
    remainingCredits: remainingCycleCredits = 0,
    // eslint-disable-next-line prefer-const
    isLocked: isCycleCreditLocked,
  } = cycle || {};
  let {
    remainingCredits: remainingTopUpCredits = 0,
    // eslint-disable-next-line prefer-const
    isLocked: isTopUpCreditLocked,
  } = topUp || {};
  let {
    remainingCredits: remainingCustomCredits = 0,
    // eslint-disable-next-line prefer-const
    isLocked: isCustomCreditLocked,
  } = custom || {};

  const { limitedFeature } = useSelector((state) => state.dialog);
  const { defaultGlobalVoice, filterVoice } = useSelector(
    (state) => state.voice,
  );
  const maxLengthInputText = ttsUser?.maxLengthInputText || 0;
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const ws = useRef(null);
  const currentIsPlayingAudio = useRef(null);
  const toolbarRef = useRef(null);
  const currentReqPreviewId = useRef(requestPreviewId);
  const dispatch = useDispatch();
  const history = useHistory();
  const TTSRef = useRef();
  const { isAudioLoading } = useSelector((state) => state.audioPlayer);
  const { canUseEOLVoice } = useCanUseEOLVoice();
  const location = useLocationRouter();
  const hashValue = location.hash ? location.hash.slice(1) : '';
  const isOpenCommunityVoice = hashValue === COMMUNITY_VOICE;

  const { isCustomerSupportView, urlRequestId } = useCustomerSupportView();
  const queryParams = new URLSearchParams(location.search);
  const voiceCode = queryParams.get(VOICE_CODE);
  const showVoice = queryParams.get(SHOW_VOICES);

  const canUserUseVoiceCloning = useMemo(
    () =>
      validateUserPackageCanUseVoiceCloning({
        ttsUser,
        isUserInWhiteList: isSynthesisVoiceCloning,
        voice,
      }),
    [ttsUser, isSynthesisVoiceCloning, voice],
  );

  const countCredits = useMemo(() => {
    let countLength;

    if (openSentences) {
      const detailSelectedSentences = sentences.filter((item) =>
        selectedSentences.includes(item.id),
      );
      const synthesisSentences = selectedSentences?.length
        ? detailSelectedSentences
        : sentences;

      const sumCreditSentence = (sum, item) => {
        const factor = item?.voice?.creditFactor || 1;
        return item.text ? sum + item.text.trim().length * factor : sum;
      };

      const countCreditsOfSentences = () => {
        const contentLength = synthesisSentences.reduce(sumCreditSentence, 0);

        return contentLength;
      };

      countLength = countCreditsOfSentences();
    } else if (advanceFeature)
      countLength = countCreditEditorStateLength({
        editorState: content,
        paragraphs,
        voice,
      });
    else {
      const text = content.getCurrentContent().getPlainText('\n');
      countLength = countCreditsSynthesis({
        text,
        voice,
      });
    }

    return countLength;
  }, [content, voice, sentences, advanceFeature, openSentences]);

  const handleOpenVoices = (value) => {
    const voiceOwnershipFilter = filterVoice?.voiceOwnership;
    const isClonedVoice = isClonedVoiceCode(voice?.code);
    let optionVoiceOwnership = isClonedVoice
      ? VOICE_OWNERSHIP.PERSONAL
      : VOICE_OWNERSHIP.VBEE;

    if (
      isClonedVoice &&
      (voiceOwnershipFilter === VOICE_OWNERSHIP.COMMUNITY ||
        voice?.userId !== user?.id)
    )
      optionVoiceOwnership = VOICE_OWNERSHIP.COMMUNITY;

    if (isClonedVoice && voice?.userId !== user.id)
      optionVoiceOwnership = VOICE_OWNERSHIP.COMMUNITY;

    dispatch(
      actions.voice.changeFilterVoice({
        ...filterVoice,
        voiceOwnership: optionVoiceOwnership,
      }),
    );

    setOpenVoices(value);
  };
  const handleCloseVoices = () => setOpenVoices(false);
  const handleChangeContent = (value) => setContent(value);
  const handleChangeInputLength = (value) => setInputLength(value);

  const pronunciationCheck = usePronunciationCheck({
    editorState: content,
    onChangeEditorState: handleChangeContent,
    onChangeInputLength: handleChangeInputLength,
    highlightStrategy,
    fixedWordStrategy,
    HighlightWord,
    FixedWord,
  });

  const handleCloseDraft = () => {
    setOpenDraft(false);
    deleteDataLocalStorage('dataDraft');
    dispatch(actions.synthesisRequest.updateSynthesisRequest('title', ''));
  };
  const handleOpenDraft = () => {
    if (isCustomerSupportView) return;
    setOpenDraft(true);
  };
  const handleLoadDraft = () => {
    setLoadDraft(true);
    setOpenDraft(false);
    dispatch(actions.synthesisRequest.updateShowBannerProjects(false));
  };

  const handleChangeIsExpandRequest = () => {
    setIsExpandRequest(!isExpandRequest);
  };

  // const handleOpenRequest = (value) => setOpenRequest(value);
  const handleChangeCharacterExceed = (value) => setCharacterExceed(value);
  const handleChangeRequestLoading = (value) => setRequestLoading(value);
  const handleChangeSynthesisSentence = (value) => setSynthesisSentence(value);

  const handleUpdateSynthesisRequestEmphasis = (newVoice) => {
    if (!newVoice) return;

    if (newVoice?.hasEmphasis) {
      dispatch(
        actions.synthesisRequest.updateSynthesisRequest('hasEmphasis', true),
      );
      dispatch(actions.synthesisRequest.updateSynthesisRequest('emphasis', 0));
    } else {
      dispatch(
        actions.synthesisRequest.updateSynthesisRequest('hasEmphasis', false),
      );
      dispatch(actions.synthesisRequest.updateSynthesisRequest('emphasis', 0));
    }
  };

  const handleChangeVoice = (value, loadingSynthesisConfig) => {
    // Update with normal voice
    if (synthesisRequest?.voice?.code !== value?.code && !enableEditor) {
      setEnableEditor(true);
      if (!openSentences) {
        dispatch(actions.synthesisRequest.cloneSynthesisRequest(true));
      }
    }

    dispatch(actions.synthesisRequest.updateVoice(value));

    if (!loadingSynthesisConfig) {
      // The reason we only handle update emphasis when not loading synthesis config
      // is because the loadingSynthesisConfig is only activated when user click to request in request table, which will cause the loading to true
      // which will cause the voice get updated twice, since click the request in request table already update the voice.
      // If the voice is updated twice, it will update the wrong emphasis value
      handleUpdateSynthesisRequestEmphasis(value);
    }

    if (
      value?.version !== TTS_VERSION.EMPHASIS &&
      voice?.version !== TTS_VERSION.EMPHASIS
    )
      return;

    if (
      value?.code !== voice?.code &&
      !openSentences &&
      !loadingSynthesisConfig
    ) {
      let newParagraphs = [];
      let convertText = '';
      const isAdvanceFeature = value?.version === TTS_VERSION.EMPHASIS;
      if (isAdvanceFeature) {
        convertText = content.getCurrentContent().getPlainText('\n');
        newParagraphs = convertTextToParagraphs(convertText);
      } else {
        const text = convertParagraphsToText(paragraphs);
        convertText = text
          ?.replace(REGEX.EMPHASIS_TAG, '')
          ?.replace(
            REGEX.ADVANCE_BREAK_TIME_TAG,
            (p1, p2) => `<break time=${p2}s/>`,
          );
      }

      const { id, status, createdAt, endedAt, progress, ...rest } =
        synthesisRequest;
      const newSynthesisRequest =
        synthesisRequest?.voice?.code !== value?.code ? rest : synthesisRequest;

      const newSynthesisConfig = {
        ...newSynthesisRequest,
        paragraphs: newParagraphs,
        text: convertText,
        voice: value,
        characters: inputLength,
        sentences: [],
      };

      dispatch(
        actions.synthesisRequest.updateSynthesisConfig(newSynthesisConfig),
      );
      dispatch(actions.synthesisRequest.updateLoadingSynthesisConfig(true));
    }

    // Update with emphasis voice
    if (synthesisRequest?.voice?.code !== value?.code && !enableEditor) {
      setEnableEditor(true);
      dispatch(actions.synthesisRequest.cloneSynthesisRequest(true));
    }
  };

  const handleChangeIsSSML = (value) => setIsSSML(value);
  const handleChangeOpenWrongBreakTimeDialog = (value) =>
    setOpenWrongBreakTimeDialog(value);

  const handleChangeRunTourGuide = (value) => {
    // Nếu tourguide kế thúc, nếu đủ điều kiện thì hiển thị popup bản tin tuần.
    const isUserCreatedToday = moment(user?.createdAt).isSame(moment(), 'day');
    if (
      value === false &&
      !isUserCreatedToday &&
      shouldShowWeeklyHighlights({ userId: user?.id })
    ) {
      dispatch(actions.layout.openHighlightWeekDialog(true));
    }
    setRunTourGuide(value);
    dispatch(actions.user.isRunningTourGuide(value));
  };

  const handleCloseMaxCharsLimitExceededDialog = () =>
    setOpenMaxCharsLimitExceeded(false);

  const handleCloseOutOfCreditsDialog = () => setOpenOutOfCreditsDialog(false);

  const handleCloseExpiredPackageDialog = () => {
    setOpenExpiredPackageDialog(false);
  };

  const handleOpenSentences = (checkedSwitch) => {
    if (checkedSwitch) {
      dispatch(actions.synthesisRequest.updateOpenSentences(checkedSwitch));
      let newSentences;

      if (advanceFeature) {
        newSentences = newSplitParagraphIntoSentence(paragraphs, voice);
        dispatch(actions.synthesisRequest.updateParagraphs([]));
      } else {
        const plainTextContent = content.getCurrentContent().getPlainText('\n');
        newSentences = splitParagraphIntoSentence(plainTextContent, voice);
      }

      dispatch(actions.synthesisRequest.updateSentences(newSentences));
    } else {
      setConfirmSwitchParagraph(true);
    }
  };

  const handleCloseConfirmDialog = () => setConfirmSwitchParagraph(false);
  const handleCloseSSMLDialog = () => setOpenSSMLDialog(false);
  const handleCloseActionDialog = () => setActionDialog();
  const handleCloseLimitedFeatureDialog = () => {
    dispatch(actions.dialog.displayDialog({ limitedFeature: false }));
    handleCloseActionDialog();
  };

  const handleEnableEditor = (value) => setEnableEditor(value);

  const handleUpgradeNow = () => {
    dispatch(actions.user.updateShowBlockDownloadDialog(false));
    history.push(ROUTES.PAYMENT);
  };
  const renderUpgradeButton = () => (
    <Button variant="contained" onClick={handleUpgradeNow}>
      {t('upgradeNow')}
    </Button>
  );

  const renderLockedCycleButton = () => (
    <Button variant="contained" onClick={() => setOpenDialogLockedCycle(null)}>
      {t('understoodV3')}
    </Button>
  );

  const handleCloseNotificationDialogV2 = () =>
    dispatch(
      actions.dialog.displayDialogV2({
        notificationDialogV2: INIT_NOTIFICATION_DIALOG,
      }),
    );

  const getDescriptionKey = (isPreview, isMultipleVoices) => {
    if (isPreview) {
      return 'notSupportPreviewVoice';
    }
    if (isMultipleVoices) {
      return 'trialVoiceLimitDescriptionMultiple';
    }
    return 'trialVoiceLimitDescription';
  };
  const handleOpenVoiceTrialLimitDialog = (limitedVoices, isPreview) => {
    // Support both single voice (backward compatibility) and array of voices
    const voices = Array.isArray(limitedVoices)
      ? limitedVoices
      : [limitedVoices || voice];

    const packageName = t(
      getUpgradePackageLabelKey({
        voices,
        userFeatures: ttsUser?.features,
        packages: allPackages,
      }),
    );

    // Create voice names list
    const voiceNames = voices
      .map((v) => v?.name)
      .filter(Boolean)
      .join(', ');

    // For multiple voices, show list format
    const isMultipleVoices = Array.isArray(limitedVoices) && voices.length > 1;

    // Create HTML list for multiple voices
    const voiceNamesList = isMultipleVoices
      ? voices
          .map((v) => v?.name)
          .filter(Boolean)
          .map((name) => `<li><b>${sanitizeHtml(name)}</b></li>`)
          .join('')
      : '';

    dispatch(
      actions.limitedFeaturesDialog.showLimitedFeaturesDialog({
        description: t(getDescriptionKey(isPreview, isMultipleVoices), {
          voiceName: voiceNames || '',
          voiceNames: voiceNamesList,
          packageName,
        }),
        img: CrownImg,
        classNameImg: 'custom-img',
        maxWidth: '640px',
        paywall: {
          type: MOE_PAYWALL_TYPE.VOICE_TRIAL_LIMIT,
          voiceCode: voices
            .map((v) => v?.code)
            .filter(Boolean)
            .join(','),
        },
        onUpgrade: () => {
          history.push(`${ROUTES.PAYMENT}`);
          dispatch(actions.limitedFeaturesDialog.hideLimitedFeaturesDialog());
        },
      }),
    );
  };

  const renderButtonUnderstand = () => (
    <Button
      variant="contained"
      onClick={handleCloseNotificationDialogV2}
      sx={{
        float: 'right',
        marginLeft: '-10px',
        marginBottom: '-10px',
        padding: '8px 48px',
        borderRadius: '12px',
        textTransform: 'none',
        fontSize: '14px',
        fontWeight: 700,
      }}
    >
      {t('gotIt')}
    </Button>
  );
  const renderButtonUnderstandV2 = () => (
    <CommonButton
      variant="outlineSmall"
      onClick={handleCloseNotificationDialogV2}
      customStyle={{
        marginBottom: '0px',
        marginRight: '12px',
        padding: '8px 48px',
        borderRadius: '8px',
        height: '40px',
        textTransform: 'none',
      }}
      textProps={{
        variantText: 'body-14-semibold',
        color: COLOR.darkBlue,
      }}
    >
      {t('gotIt')}
    </CommonButton>
  );

  const handleAcceptConfirmDialog = () => {
    dispatch(actions.synthesisRequest.updateOpenSentences(false));
    setConfirmSwitchParagraph(false);

    if (advanceFeature) {
      const newParagraphs = convertSentenceToParagraphs(sentences);
      dispatch(actions.synthesisRequest.updateParagraphs(newParagraphs));
      dispatch(actions.synthesisRequest.updateLoadingParagraphs(true));
    } else {
      const sentencesText = sentences.map((item) => item.text);
      const paragraphText = sentencesText.join('\n');

      const paragraphEditorStyle = EditorState.createWithContent(
        ContentState.createFromText(paragraphText),
        generateDecorator(BREAK_TIME_REGEX, BreakTimeHighlight),
      );
      setContent(paragraphEditorStyle);
    }
  };

  const handleLoadContentEditor = (
    sentencesSave,
    isAdvanceFeature,
    isOpenSentences,
    isEnableEditor,
  ) => {
    setLoadDraft(false);
    setEnableEditor(isEnableEditor);
    if (isOpenSentences) {
      const newSentences = sentencesSave.filter(
        (item) => !selectedSentences.includes(item.id),
      );
      dispatch(actions.synthesisRequest.updateSentences(newSentences));
      return;
    }
    if (!isOpenSentences) {
      if (!isAdvanceFeature) {
        const sentencesText = sentencesSave.map((item) => item.text);
        const paragraphText = sentencesText.join('\n');
        const paragraphEditorStyle = EditorState.createWithContent(
          ContentState.createFromText(paragraphText),
          generateDecorator(BREAK_TIME_REGEX, BreakTimeHighlight),
        );
        setContent(paragraphEditorStyle);
      }
      if (isAdvanceFeature) {
        dispatch(actions.synthesisRequest.switchAdvanceFeature(true));
        dispatch(
          actions.synthesisRequest.updateSynthesisRequest(
            'paragraphs',
            sentencesSave,
          ),
        );
      }
    }
  };

  const checkValidatePreviewSentence = (sentence) => {
    const {
      elements,
      previewParagraphs,
      voice: sentenceVoice,
      speed,
    } = sentence;

    const isExpiredPackage =
      packageExpiryDate && moment().isAfter(packageExpiryDate);

    if (isExpiredPackage) {
      trackTtsPaywall(MOE_PAYWALL_TYPE.EXPIRED_PACKAGE, {
        trigger: MOE_PAYWALL_TRIGGER.PREVIEW,
      });
      setOpenExpiredPackageDialog(true);
      return { error: true };
    }
    let text;
    if (advanceFeature) {
      const { error, detailError } = openSentences
        ? checkSyntaxTagsElements(elements)
        : checkSyntaxTagsParagraphs(previewParagraphs, sentenceVoice?.provider);

      if (error) {
        setOpenWrongSyntaxDialog({
          name: 'error-syntax',
          variant: 'warning',
          title: t('errorSyntax'),
          description: t('errorSyntaxDescription'),
          subDescription: t(detailError),
        });
        return { error: true };
      }
      text = openSentences
        ? convertElementsToText(elements)
        : convertParagraphsToText(previewParagraphs);
      if (BREAK_TIME_REGEX.test(text)) {
        setOpenWrongSyntaxDialog({
          name: 'error-syntax',
          variant: 'warning',
          title: t('errorSyntax'),
          description: t('errorSyntaxDescription'),
          subDescription: t('invalidBreakTime'),
        });
        return { error: true };
      }
    } else {
      text = sentence?.text;
    }

    if (!text || !text.trim()) {
      setOpenWrongSyntaxDialog({
        name: 'error-syntax',
        variant: 'warning',
        title: t('errorSyntax'),
        description: t('errorSyntaxDescription'),
      });
      return { error: true };
    }

    const plainText = text
      .replace(REGEX.ADVANCE_TAG, '')
      .replace(BREAK_TIME_REGEX, ' ')
      .replace(/  +/g, ' ');
    const blackWordsInText = blackWords.filter((blackWord) =>
      containsBlacklistedWords({
        text: plainText,
        blackWord,
      }),
    );
    if (blackWordsInText.length > 0) {
      const blackWordsInTextRegex = blackWordsInText.map((blackWord) =>
        blackWord.replaceAll(' ', ' +'),
      );
      const regex = !currentBrowser?.safariAgent
        ? new RegExp(
            `(?<![${VALID_LETTERS}])(${blackWordsInTextRegex.join(
              '|',
            )})(?![${VALID_LETTERS}])`,
            'gi',
          )
        : new RegExp(
            `(^|[^${VALID_LETTERS}])(${blackWordsInTextRegex.join(
              '|',
            )})([^${VALID_LETTERS}]|$)`,
            'gi',
          );

      const stateContent = EditorState.set(content, {
        decorator: new CompositeDecorator([
          {
            strategy: (contentBlock, callback) => {
              findWithRegexEditor(regex, contentBlock, callback);
            },
            component: BlackWordHighLight,
          },
          {
            strategy: getEntityStrategy('MUTABLE'),
            component: HightLightSpan,
          },
        ]),
      });
      handleChangeContent(stateContent);

      apis.warning.sendWarningInvalidRequest({
        text,
        invalidTexts: blackWordsInText,
        type: WARNING_REQUEST_TYPE.BLACK_WORD,
      });

      setOpenWrongSyntaxDialog({
        name: 'error-syntax',
        variant: 'warning',
        title: t('sentenceHasBlackWords'),
        description: t('sentenceHasBlackWordsDescription'),
      });
      return { error: true };
    }

    if (sentenceVoice?.provider === VOICE_PROVIDER.VBEE) {
      const invalidTexts = text.match(VALID_CHARACTERS_LENGTH_REGEX) || [];
      const isValidText = VALID_CHARACTERS_REGEX.test(text);
      if (!isValidText) invalidTexts.push(text);

      if (invalidTexts?.length) {
        const invalidText = invalidTexts.join(', ');
        setOpenWrongSyntaxDialog({
          name: 'error-syntax',
          variant: 'warning',
          title: t('errorSyntax'),
          description: t('errorSyntaxDescription'),
          subDescription: t('invalidCharacter', { invalidText }),
        });
        apis.warning.sendWarningInvalidRequest({
          text,
          invalidTexts,
          type: WARNING_REQUEST_TYPE.CHARACTER_EXCEED,
        });
        return { error: true };
      }
    }

    const invalidSpeed = speed < VALID_SPEED.min || speed > VALID_SPEED.max;
    if (invalidSpeed) {
      dispatch(
        actions.noti.push({
          severity: 'warning',
          message: 'speedInvalidRange',
          value: t('range', {
            min: `${VALID_SPEED.min}x`,
            max: `${VALID_SPEED.max}x`,
          }),
        }),
      );
      return { error: true };
    }

    const regex = advanceFeature ? REGEX.ADVANCE_TAG : BREAK_TIME_REGEX;
    const countLength = countTextLength(text, regex);
    const maxTryListeningCharacters =
      ttsUser.maxLengthDemoInput || MAX_TRY_LISTENING_CHARACTERS;
    if (!countLength || countLength > maxTryListeningCharacters) {
      dispatch(
        actions.noti.push({
          severity: 'warning',
          message: 'warningListening',
          value: maxTryListeningCharacters,
        }),
      );
      return { error: true };
    }
    return { error: false, previewData: { ...sentence, text } };
  };

  const handlePreviewSentence = (sentence) => {
    const { error, previewData } = checkValidatePreviewSentence(sentence);
    if (error) return;

    const { id: sentenceId, text, voice: sentenceVoice, speed } = previewData;

    dispatch(
      actions.audioPlayer.updatePreviewRequestInfo({
        voice,
        title: t('preview'),
      }),
    );
    dispatch(actions.audioPlayer.updateShowAudioPlayer(true));

    const checkEmphasisInText = REGEX.ADVANCE_TAG.test(text);
    const suitableVersion = checkEmphasisInText
      ? VOICE_VERSION.ADVANCE
      : VOICE_VERSION.NORMAL;

    dispatch(actions.audioPlayer.updateAudioLink(''));
    dispatch(actions.audioPlayer.updateSelectedAudioRequest(''));
    dispatch(actions.audioPlayer.updateStatus(false));
    dispatch(actions.audioPlayer.updateStatusStreamAudio(false));
    dispatch(
      actions.audioPlayer.initStreamAudios(
        suitableVersion || sentenceVoice?.version,
      ),
    );
    dispatch(actions.audioPlayer.updateAudioType(PLAYING_AUDIO_TYPE.SILENCE));
    dispatch(
      actions.audioPlayer.updateMetaData({ currentTime: 0, duration: 0 }),
    );
    dispatch(
      actions.audioPlayer.updateTryListeningSentence({
        isAudioLoading: true,
        sentenceId,
      }),
    );

    const { audioType, bitrate, backgroundMusic, volume, clientPause } =
      synthesisRequest;

    const payload = {
      text,
      voiceCode: sentenceVoice?.code,
      speed,
      audioType,
      volume,
      clientPause,
    };

    if (advanceFeature) {
      payload.bitrate = bitrate;
      payload.version = TTS_VERSION.EMPHASIS;
    } else {
      payload.bitrate = bitrate;
    }

    const hasBackgroundMusic =
      backgroundMusic && Object.keys(backgroundMusic).length;
    if (hasBackgroundMusic) {
      const { link, name, volume: bgVolume } = backgroundMusic;
      payload.backgroundMusic = { link, name, volume: bgVolume };
    }

    if (synthesisRequest?.hasEmphasis) {
      payload.emphasisIntensity = synthesisRequest?.emphasis;
    }

    if (aiPronunciationCheckEnabled) {
      const nswPayload = getNswPayloadFromContent(
        content.getCurrentContent(),
        content.getSelection(),
      );
      if (nswPayload.length > 0) {
        payload.nsw = nswPayload;
      }
    }

    setPreviewPayload(payload);
  };

  const handlePreviewTrialAction = (previewSentence) => {
    handlePreviewSentence(previewSentence);
    handleCloseActionDialog();
  };

  const checkVoicePermission = (currentVoice = voice) => {
    const isVietNam = checkVietNam();
    const isDefaultGlobalVoice =
      !isVietNam &&
      usingPackage?.level === PACKAGE_LEVEL.BASIC &&
      currentVoice?.code === defaultGlobalVoice;

    return (
      !currentVoice?.features?.length ||
      isDefaultGlobalVoice ||
      currentVoice.features.every((item) =>
        checkFeaturePermission(ttsUser.features, item),
      ) ||
      canUseEOLVoice({ voice, user })
    );
  };

  const checkOutputAudioTypePermission = () => {
    const isPackageV2 =
      usingPackage?.version === PACKAGE_STUDIO_VERSION.V2 ||
      usingPackage?.version === PACKAGE_STUDIO_VERSION.V2_1;
    if (!isPackageV2) return true;
    if (!synthesisRequest?.audioType) return true;
    const ouputAudio = OUTPUT_AUDIO.find(
      (item) => item.type === synthesisRequest?.audioType,
    );
    const hasFeature = checkFeaturePermission(
      ttsUser?.features,
      ouputAudio?.feature,
    );
    return hasFeature;
  };

  const checkConditionPackageToPreview = (sentence) => {
    const isRenameVoice =
      voiceHasBeenRenamed && !voice?.active && !!voice?.canonicalVoice?.name;

    if (isRenameVoice) {
      setOpenWrongSyntaxDialogV2({
        name: 'error-syntax',
        variant: 'none',
        title: t('notice'),
        description: sanitizeHtml(
          t('voiceHasBeenRenamed', {
            newName: synthesisRequest?.voice?.canonicalVoice?.name,
          }),
          {
            allowedTags: ['strong'],
          },
        ),
        type: DIALOG_V2_TYPE.RENAME_VOICE,
      });
      return;
    }
    if (!ttsUser.features.includes(FEATURE.PREVIEW)) {
      setActionDialog({
        image: UpgradeImg,
        title: t('premiumFeature'),
        description: t('premiumFeatureDescription'),
        onClose: handleCloseActionDialog,
        actionComponents: renderUpgradeButton(),
      });
      return;
    }

    if (
      !canUserUseVoiceCloning &&
      voice?.provider === VOICE_PROVIDER.VBEE_VOICE_CLONING &&
      voice?.userId === user?.id &&
      voice?.status === SUB_STATUS.PRIVATE
    ) {
      if (voice?.type === VOICE_CLONE_TYPE.ZERO_SHOT)
        dispatch(
          actions.limitedFeaturesDialog.showLimitedFeaturesDialog({
            description: t('instantVoiceCloningUpgrade'),
            img: CrownImg,
            classNameImg: 'custom-img',
            showButtonUnderstand: true,
            onUpgrade: () => {
              history.push(ROUTES.PAYMENT);
              dispatch(
                actions.limitedFeaturesDialog.hideLimitedFeaturesDialog(),
              );
            },
            maxWidth: 'sm',
          }),
        );
      else
        dispatch(
          actions.limitedFeaturesDialog.showLimitedFeaturesDialog({
            description: t('voiceCloningUpgrade'),
            img: CrownImg,
            classNameImg: 'custom-img',
            onUpgrade: () => {
              history.push(ROUTES.PAYMENT);
              dispatch(
                actions.limitedFeaturesDialog.hideLimitedFeaturesDialog(),
              );
            },
          }),
        );
      return;
    }

    if (LIMITED_PREVIEW_PACKAGE_LEVEL.includes(usingPackage.level)) {
      if (!remainingPreview)
        setActionDialog({
          image: UpgradeImg,
          title: t('previewOver'),
          description: t('previewOverDescription'),
          onClose: handleCloseActionDialog,
          actionComponents: renderUpgradeButton(),
        });
      else {
        setActionDialog({
          image: TrialPreviewImage,
          title: t('previewTrial', { remainingPreview }),
          description: t('previewTrialDescription'),
          onClose: handleCloseActionDialog,
          actionComponents: (
            <>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleCloseActionDialog}
              >
                {t('noValue')}
              </Button>
              <Button
                variant="contained"
                onClick={() => handlePreviewTrialAction(sentence)}
              >
                {t('preview')}
              </Button>
            </>
          ),
        });
      }
      return;
    }

    if (
      ttsUser?.packageCode &&
      checkFreePackage(ttsUser?.packageCode) &&
      ttsUser?.maxPreview &&
      usedFreePreviews >= ttsUser?.maxPreview
    ) {
      dispatch(
        actions.limitedFeaturesDialog.showLimitedFeaturesDialog({
          description: t('trialEndedMessage'),
          img: CrownImg,
          classNameImg: 'custom-img',
          maxWidth: '640px',
          onUpgrade: () => {
            history.push(ROUTES.PAYMENT);
            dispatch(actions.limitedFeaturesDialog.hideLimitedFeaturesDialog());
          },
        }),
      );
      return;
    }

    const canUseVoice = checkVoicePermission(sentence?.voice || voice);
    if (!canUseVoice) {
      handleOpenVoiceTrialLimitDialog(sentence?.voice || voice, true);
      return;
    }

    handlePreviewSentence(sentence);
  };

  const getTextLength = () => {
    let countLength;

    if (openSentences) {
      const detailSelectedSentences = sentences.filter((item) =>
        selectedSentences.includes(item.id),
      );
      const synthesisSentences = selectedSentences?.length
        ? detailSelectedSentences
        : sentences;

      countLength = countTextLengthOfSentences(synthesisSentences);
    } else if (advanceFeature)
      countLength = countEditorStateLength(content, paragraphs);
    else {
      const text = content.getCurrentContent().getPlainText('\n');
      const regex = advanceFeature ? REGEX.ADVANCE_TAG : BREAK_TIME_REGEX;
      countLength = countTextLength(text, regex);
    }

    return countLength;
  };

  const openLimitedFeatureDialog = (
    featureKey,
    paywallType,
    paywallVoiceCode,
  ) => {
    dispatch(
      actions.limitedFeaturesDialog.showLimitedFeaturesDialog({
        description: t('limitedFeatureDesc', { feature: t(featureKey) }),
        paywall: { type: paywallType, voiceCode: paywallVoiceCode, featureKey },
      }),
    );
  };

  const getSynthesisSentences = () => {
    if (!openSentences) return [];
    const detailSelectedSentences = sentences.filter((item) =>
      selectedSentences.includes(item.id),
    );
    return selectedSentences?.length ? detailSelectedSentences : sentences;
  };

  const calculateVoiceCreditsMapWithTimes = (sentencesList) => {
    const voiceCreditsMap = calculateVoiceCreditsMap(sentencesList);

    // Count sentences per voice using reduce
    const voiceTimesMap = sentencesList.reduce((acc, sentence) => {
      const code = sentence?.voice?.code;
      if (code) {
        acc[code] = 1;
      }
      return acc;
    }, {});

    // Add times to each voice and convert to object with voice code as key
    return Object.values(voiceCreditsMap).reduce((acc, item) => {
      acc[item.voice?.code] = {
        ...item,
        times: voiceTimesMap[item.voice?.code] || 1,
      };
      return acc;
    }, {});
  };

  // Helper function to collect trial usage candidates
  const getTrialUsageCandidates = () => {
    if (!enableVoiceTrial) return [];

    if (openSentences) {
      const synthesisSentences = getSynthesisSentences();
      const voiceCreditsMapWithTimes =
        calculateVoiceCreditsMapWithTimes(synthesisSentences);
      return Object.values(voiceCreditsMapWithTimes);
    }

    if (voice?.code) {
      const totalCharacters = getTextLength() || 0;
      const creditFactor = voice?.creditFactor || 1;
      const credits = totalCharacters * creditFactor;
      return [{ voice, credits, times: 1 }];
    }

    return [];
  };

  const checkValidCreateSynthesis = () => {
    const canUseVoice = checkVoicePermission();
    const canOutputAudioType = checkOutputAudioTypePermission();

    // Check trial eligibility based on mode
    const isUsingVoiceTrial = openSentences
      ? // Sentences mode: check if any voice in sentences is using trial
        getSynthesisSentences().some(
          (sentence) =>
            sentence?.voice &&
            isUsingTrialVoice(
              sentence.voice,
              voiceTrialConfig,
              ttsUser?.features,
              checkFeaturePermission,
            ),
        )
      : // Single voice mode
        isVoiceEligibleForTrial(voice, voiceTrialConfig) && !canUseVoice;
    const isRenameVoice =
      voiceHasBeenRenamed && !voice?.active && !!voice?.canonicalVoice?.name;

    if (isRenameVoice) {
      setOpenWrongSyntaxDialogV2({
        name: 'error-syntax',
        variant: 'none',
        title: t('notice'),
        description: sanitizeHtml(
          t('voiceHasBeenRenamed', {
            newName: synthesisRequest?.voice?.canonicalVoice?.name,
          }),
          {
            allowedTags: ['strong'],
          },
        ),
        type: DIALOG_V2_TYPE.RENAME_VOICE,
      });
      return false;
    }
    // Check audio type
    if (!canOutputAudioType) {
      openLimitedFeatureDialog(
        OUTPUT_AUDIO.find((item) => item.type === synthesisRequest.audioType)
          ?.featureDesc,
      );
      return false;
    }
    // Check voice trial limit
    if (isUsingVoiceTrial) {
      if (openSentences) {
        // Sentences mode: check each voice
        const synthesisSentences = getSynthesisSentences();
        const voiceCreditsMapWithTimes =
          calculateVoiceCreditsMapWithTimes(synthesisSentences);

        const exceededVoices = findExceededTrialVoices(
          voiceCreditsMapWithTimes,
          voiceTrialConfig,
          stateTrialVoiceUsage,
          ttsUser?.features,
          checkFeaturePermission,
        );

        if (exceededVoices.length > 0) {
          const exceededVoiceObjects = exceededVoices.map((item) => item.voice);
          handleOpenVoiceTrialLimitDialog(exceededVoiceObjects);
          return false;
        }
      } else {
        // Single voice mode: check with countCredits
        const isTrialEligible = isVoiceEligibleForTrial(
          voice,
          voiceTrialConfig,
        );
        if (
          isTrialEligible &&
          willExceedTrialLimit(
            voice,
            voiceTrialConfig,
            stateTrialVoiceUsage,
            countCredits || 0,
          )
        ) {
          handleOpenVoiceTrialLimitDialog(voice);
          return false;
        }
      }
    }

    const isTrialEligible = isVoiceEligibleForTrial(voice, voiceTrialConfig);
    if (!canUseVoice && !isTrialEligible) {
      openLimitedFeatureDialog(
        'useThisVoice',
        MOE_PAYWALL_TYPE.LOCKED_VOICE,
        voice?.code,
      );
      return false;
    }

    // Check input text length
    const countLength = getTextLength();
    if (!countCredits) {
      setStepsGuide(STEPS_ENTER_TEXT_HERE_GUIDE);
      setRunTourGuide(true);
      return false;
    }
    if (countLength > maxLengthInputText) {
      trackTtsPaywall(MOE_PAYWALL_TYPE.MAX_CHARS, {
        characters: countLength,
        maxCharacters: maxLengthInputText,
      });
      setOpenMaxCharsLimitExceeded(true);
      return false;
    }

    // Check package expired
    const isExpiredPackage =
      packageExpiryDate && moment().isAfter(packageExpiryDate);

    if (isExpiredPackage) {
      trackTtsPaywall(MOE_PAYWALL_TYPE.EXPIRED_PACKAGE);
      setOpenExpiredPackageDialog(true);
      return false;
    }

    const isLockedCycle =
      isCycleCreditLocked &&
      !remainingTopUpCredits &&
      !remainingCharacters &&
      !bonusCharacters;

    const isLockedTopUp =
      isTopUpCreditLocked && !remainingCharacters && !bonusCharacters;

    if (isLockedCycle || isLockedTopUp) {
      trackTtsPaywall(MOE_PAYWALL_TYPE.LOCKED_CREDITS, {
        lockedWallet: isLockedCycle
          ? MOE_LOCKED_WALLET.CYCLE
          : MOE_LOCKED_WALLET.TOPUP,
      });
      setOpenDialogLockedCycle({
        title: t('charactersTemporarilyLocked'),
        description: t('descriptionPopupLockedCredit'),
      });
      return false;
    }

    const usageRemainingCharacters = remainingCharacters;
    if (isCycleCreditLocked) remainingCycleCredits = 0;
    if (isTopUpCreditLocked) remainingTopUpCredits = 0;
    if (isCustomCreditLocked) remainingCustomCredits = 0;

    // eslint-disable-next-line no-shadow
    const totalCredits =
      usageRemainingCharacters +
      bonusCharacters +
      remainingCycleCredits +
      remainingTopUpCredits +
      remainingCustomCredits;
    // TODO: check feature flag for this condition if rollback to old version
    if (countCredits > totalCredits) {
      if (remainingCharacters > 0 && usageRemainingCharacters === 0)
        setWarningOneTimeCredits(true);
      trackTtsPaywall(MOE_PAYWALL_TYPE.OUT_OF_CREDITS, {
        creditsNeeded: countCredits,
        creditsRemaining: totalCredits,
        characters: countLength,
        voiceCode: voice?.code,
      });
      setOpenOutOfCreditsDialog(true);
      return false;
    }

    const isNotUsingPackage = !usingPackage.id;
    if (isNotUsingPackage) {
      trackTtsPaywall(MOE_PAYWALL_TYPE.NO_PACKAGE);
      setActionDialog({
        image: UpgradeImg,
        title: t('noPackage'),
        description: t('noteNoPackage'),
        onClose: handleCloseActionDialog,
        actionComponents: renderUpgradeButton(),
      });
      return false;
    }

    const { speed } = synthesisRequest;

    const invalidSpeed =
      !openSentences && (speed < VALID_SPEED.min || speed > VALID_SPEED.max);
    if (invalidSpeed) {
      dispatch(
        actions.noti.push({
          severity: 'warning',
          message: 'speedInvalidRange',
          value: t('range', {
            min: `${VALID_SPEED.min}x`,
            max: `${VALID_SPEED.max}x`,
          }),
        }),
      );
      return false;
    }
    return true;
  };

  const handleResetContentEditor = () => {
    setInputLength(0);
    deleteDataLocalStorage(`dataDraft-${user.id}`);
    dispatch(actions.synthesisRequest.updateSynthesisRequest('title', ''));
    if (openSentences) {
      const { voice: sentenceVoice = {} } = sentences[0];
      const initSentences = splitParagraphIntoSentence('', sentenceVoice);

      dispatch(actions.synthesisRequest.updateSentences(initSentences));
      dispatch(actions.synthesisRequest.updateSelectedSentences([]));

      return;
    }

    dispatch(actions.synthesisRequest.updateParagraphs([]));
    if (advanceFeature) {
      setContent(EditorState.createEmpty(Decorator));
      return;
    }
    setContent(
      EditorState.createEmpty(
        generateDecorator(BREAK_TIME_REGEX, BreakTimeHighlight),
      ),
    );
  };

  const handleCreateNewEditor = (isNew) => {
    handleEnableEditor(true);
    const {
      status,
      id,
      endedAt,
      processingAt,
      progress,
      title,
      ...newSynthesisRequest
    } = synthesisRequest;
    dispatch(
      actions.synthesisRequest.updateSynthesisConfig(newSynthesisRequest),
    );
    if (isNew) handleResetContentEditor();
  };

  const generateVoiceSummary = (voices) => {
    if (!Array.isArray(voices) || voices.length === 0) {
      return "<ul style='margin: 0 0 0 10px; padding: 0;'>\n<li>No voices available.</li>\n</ul>";
    }

    const voiceList = voices
      .map((item) => {
        const voiceName = item.name;
        const voiceLevel = item.level ? t(item.level) : '';
        const isBeta = item.beta ? 'Beta' : '';
        // voiceNote combine voiceLevel and isBeta
        const voiceNote = [voiceLevel, isBeta].filter(Boolean).join(' - ');
        const factor = item.creditFactor || 1;
        return t('voiceFactor', {
          voiceName,
          voiceNote: voiceNote ? `(${voiceNote})` : '',
          isBeta,
          factor,
        });
      })
      .join('\n');

    return t('totalFactorCredits', {
      voiceList,
      countCredits: countCredits?.toLocaleString(language),
    });
  };

  const showWarningCannotUseVoiceDialog = () => {
    setOpenWrongSyntaxDialogV2({
      name: 'error-syntax',
      variant: 'warning',
      title: t('notice'),
      description: sanitizeHtml(
        t(
          userVoiceEolEnabled
            ? 'eolVoiceoverHasBeenDiscontinuedV2'
            : 'eolVoiceoverHasBeenDiscontinued',
          { voiceName: formatNameForEOL(voice.name, userVoiceEolEnabled) },
        ),
        {
          allowedTags: ['p', 'strong'],
          allowedAttributes: {
            '*': ['style'],
          },
        },
      ),
      type: DIALOG_V2_TYPE.CANNOT_USE_VOICE,
    });
  };

  const showWarningFactorCharcterDialog = () => {
    const processSentences = selectedSentences?.length
      ? selectedSentences
      : sentences;
    const highCreditFactorVoices = openSentences
      ? processSentences
          .filter((sentence) => sentence?.voice?.creditFactor > 1)
          .map((sentence) => sentence?.voice)
      : [voice]?.filter((v) => v?.creditFactor > 1);

    const highCreditFactorVoicesUnique = highCreditFactorVoices.filter(
      (currVoice, index, self) =>
        index ===
        self.findIndex(
          (tVoice) =>
            tVoice.code === currVoice.code &&
            tVoice.provider === currVoice.provider,
        ),
    );

    if (!highCreditFactorVoicesUnique.length) return;
    setOpenWrongSyntaxDialogV2({
      name: 'error-syntax',
      variant: 'warning',
      title: t('note'),
      description: generateVoiceSummary(highCreditFactorVoicesUnique),
      type: DIALOG_V2_TYPE.NON_VBEE_WARNING,
    });
  };

  const checkVoiceFactorGreaterThanOne = () => {
    const voiceCredits = voice?.creditFactor || 1;
    if (!openSentences && voiceCredits > 1) return true;

    // Voice factor greater than 1
    const processSentences = selectedSentences?.length
      ? selectedSentences
      : sentences;
    const hasHighVoiceFactor = processSentences.some(
      (sentence) => (sentence?.voice?.creditFactor || 1) > 1,
    );
    if (hasHighVoiceFactor && openSentences) return true;

    return false;
  };

  // TODO: change name => showCharsFactorWarning
  const showNonVbeeWarning = useMemo(() => {
    let charsFactorDialog = localStorage.getItem('charsFactorDialog');
    charsFactorDialog = charsFactorDialog || charsFactorCheckbox;
    const useVoiceFactorGreaterThanOne = checkVoiceFactorGreaterThanOne();
    return useVoiceFactorGreaterThanOne && !charsFactorDialog;
  }, [charsFactorCheckbox, voice, sentences]);

  const createSynthesisRequest = async () => {
    const {
      title,
      audioType,
      bitrate,
      backgroundMusic,
      volume,
      hasEmphasis,
      emphasis,
    } = synthesisRequest;
    const detailSelectedSentences = sentences.filter((item) =>
      selectedSentences.includes(item.id),
    );
    const synthesisSentences = selectedSentences?.length
      ? detailSelectedSentences
      : sentences;
    const trialUsageCandidates = getTrialUsageCandidates();
    let synthesisPayload = { audioType, volume };
    if (advanceFeature) {
      synthesisPayload.bitrate = bitrate || BITRATE[BITRATE.length - 1];
    } else {
      synthesisPayload.bitrate = bitrate || BITRATE[BITRATE.length - 1];
    }

    if (title) synthesisPayload.title = title.trim();

    const hasBackgroundMusic =
      backgroundMusic && Object.keys(backgroundMusic).length;
    if (hasBackgroundMusic) {
      const { link, name, volume: bgVolume } = backgroundMusic;
      synthesisPayload.backgroundMusic = { link, name, volume: bgVolume };
    }
    if (advanceFeature) {
      synthesisPayload.version = TTS_VERSION.EMPHASIS;
      const needCheckParagraphs = openSentences
        ? synthesisSentences
        : paragraphs;

      const { error, detailError } =
        checkSyntaxTagsParagraphs(needCheckParagraphs);
      if (error) {
        setOpenWrongSyntaxDialog({
          name: 'error-syntax',
          variant: 'warning',
          title: t('errorSyntax'),
          description: t('errorSyntaxDescription'),
          subDescription: t(detailError),
        });
        return;
      }
    }

    if (openSentences) {
      let sentencesPayload;
      if (advanceFeature) {
        sentencesPayload = newGetSentencesPayload(synthesisSentences);
        const invalidBreakTime = sentencesPayload.some((sentence) =>
          BREAK_TIME_REGEX.test(sentence.text),
        );
        if (invalidBreakTime) {
          setOpenWrongSyntaxDialog({
            name: 'error-syntax',
            variant: 'warning',
            title: t('errorSyntax'),
            description: t('errorSyntaxDescription'),
            subDescription: t('invalidBreakTime'),
          });
          return;
        }
      } else {
        sentencesPayload = getSentencesPayload(synthesisSentences);
        const hasZeroBreakTime = synthesisSentences.some((sentence) =>
          ZERO_BREAK_TIME_REGEX.test(sentence.text),
        );
        if (hasZeroBreakTime) {
          handleChangeOpenWrongBreakTimeDialog(true);
          return;
        }
      }
      const invalidTexts = sentencesPayload.reduce((acc, curr) => {
        const { text, voiceProvider } = curr;

        if (voiceProvider === VOICE_PROVIDER.VBEE) {
          const invalidSentenceText = text.match(VALID_CHARACTERS_LENGTH_REGEX);
          if (invalidSentenceText?.length) return invalidSentenceText;
          const isValidText = VALID_CHARACTERS_REGEX.test(text);
          if (!isValidText) return [text];
        }

        return acc;
      }, []);
      if (invalidTexts.length) {
        const invalidText = invalidTexts.join(', ');
        setOpenWrongSyntaxDialog({
          name: 'error-syntax',
          variant: 'warning',
          title: t('errorSyntax'),
          description: t('errorSyntaxDescription'),
          subDescription: t('invalidCharacter', { invalidText }),
        });
        const text = sentencesPayload
          .map((sentence) => sentence.text)
          .join('\n');
        apis.warning.sendWarningInvalidRequest({
          text,
          invalidTexts,
          type: WARNING_REQUEST_TYPE.CHARACTER_EXCEED,
        });

        setOpenWrongSyntaxDialog({
          name: 'error-syntax',
          variant: 'warning',
          title: t('sentenceHasBlackWords'),
          description: t('sentenceHasBlackWordsDescription'),
        });
        return;
      }
      // validate black words in sentences when open sentences
      const text = sentencesPayload.map((sentence) => sentence.text).join('\n');
      const plainText = text
        .replace(REGEX.ADVANCE_TAG, '')
        .replace(BREAK_TIME_REGEX, ' ')
        .replace(/  +/g, ' ');
      const blackWordsInText = blackWords.filter((blackWord) =>
        containsBlacklistedWords({
          text: plainText,
          blackWord,
        }),
      );
      if (blackWordsInText.length > 0) {
        dispatch(
          actions.synthesisRequest.updateBlackWordsInText(blackWordsInText),
        );

        apis.warning.sendWarningInvalidRequest({
          text,
          invalidTexts: blackWordsInText,
          type: WARNING_REQUEST_TYPE.BLACK_WORD,
        });

        setOpenWrongSyntaxDialog({
          name: 'error-syntax',
          variant: 'warning',
          title: t('sentenceHasBlackWords'),
          description: t('sentenceHasBlackWordsDescription'),
        });
        return;
      }
      synthesisPayload = { ...synthesisPayload, sentences: sentencesPayload };
    } else {
      let text;

      if (advanceFeature) {
        text = convertParagraphsToText(paragraphs);
        if (BREAK_TIME_REGEX.test(text)) {
          setOpenWrongSyntaxDialog({
            name: 'error-syntax',
            variant: 'warning',
            title: t('errorSyntax'),
            description: t('errorSyntaxDescription'),
            subDescription: t('invalidBreakTime'),
          });
          return;
        }
      } else {
        text = content.getCurrentContent().getPlainText('\n');
        const hasZeroBreakTime = ZERO_BREAK_TIME_REGEX.test(text);
        if (hasZeroBreakTime) {
          handleChangeOpenWrongBreakTimeDialog(true);
          return;
        }
      }

      // validate blackWords
      const plainText = text
        .replace(REGEX.ADVANCE_TAG, '')
        .replace(BREAK_TIME_REGEX, ' ');
      const blackWordsInText = blackWords.filter((blackWord) =>
        containsBlacklistedWords({
          text: plainText,
          blackWord,
        }),
      );
      const blackWordsInTextRegex = blackWordsInText.map((blackWord) =>
        blackWord.replaceAll(' ', ' +'),
      );
      if (blackWordsInText.length > 0) {
        const regex = !currentBrowser?.safariAgent
          ? new RegExp(
              `(?<![${VALID_LETTERS}])(${blackWordsInTextRegex.join(
                '|',
              )})(?![${VALID_LETTERS}])`,
              'gi',
            )
          : new RegExp(
              `(^|[^${VALID_LETTERS}])(${blackWordsInTextRegex.join(
                '|',
              )})([^${VALID_LETTERS}]|$)`,
              'gi',
            );

        const stateContent = EditorState.set(content, {
          decorator: new CompositeDecorator([
            {
              strategy: (contentBlock, callback) => {
                findWithRegexEditor(regex, contentBlock, callback);
              },
              component: BlackWordHighLight,
            },
            {
              strategy: getEntityStrategy('MUTABLE'),
              component: HightLightSpan,
            },
          ]),
        });
        handleChangeContent(stateContent);

        apis.warning.sendWarningInvalidRequest({
          text,
          invalidTexts: blackWordsInText,
          type: WARNING_REQUEST_TYPE.BLACK_WORD,
        });

        setOpenWrongSyntaxDialog({
          name: 'error-syntax',
          variant: 'warning',
          title: t('sentenceHasBlackWords'),
          description: t('sentenceHasBlackWordsDescription'),
        });
        return;
      }

      if (voice?.provider === VOICE_PROVIDER.VBEE) {
        const invalidTexts =
          text.match(
            currentBrowser?.safariAgent
              ? VALID_CHARACTERS_REGEX_SAFARI
              : VALID_CHARACTERS_LENGTH_REGEX,
          ) || [];
        const isValidText = VALID_CHARACTERS_REGEX.test(text);
        if (!isValidText) invalidTexts.push(text);

        if (invalidTexts?.length) {
          const invalidText = invalidTexts.join(', ');
          setOpenWrongSyntaxDialog({
            name: 'error-syntax',
            variant: 'warning',
            title: t('errorSyntax'),
            description: t('errorSyntaxDescription'),
            subDescription: t('invalidCharacter', { invalidText }),
          });
          apis.warning.sendWarningInvalidRequest({
            text,
            invalidTexts,
            type: WARNING_REQUEST_TYPE.CHARACTER_EXCEED,
          });
          return;
        }
      }

      if (isSSML) {
        if (checkValidXml(text)) {
          // TODO: map ssml to payload before call api
        } else setOpenSSMLDialog(true);
        return;
      }

      if (hasEmphasis) {
        synthesisPayload.emphasisIntensity = emphasis;
      }

      synthesisPayload = {
        ...synthesisPayload,
        text,
        paragraphs: advanceFeature && !openSentences ? paragraphs : undefined,
        voiceCode: voice?.code,
        speed: Number(synthesisRequest.speed),
      };
    }

    setLoading(false);

    // const isStandardData = getFeatureValue(
    //   FEATURE_KEYS.STANDARDIZATION_USER_DATA_MOE,
    // );
    // if (!isStandardData)
    //   window.dataLayer.push({
    //     event: EVENT_TYPE.STUDIO_CONVERT_TTS,
    //     userId: user?.id,
    //     email: user.email,
    //     requestType: 'requestTTS',
    //     voice: voice?.name,
    //     characters: inputLength,
    //     package: user.packageCode,
    //     remainingCharacters: user.remainingCharacters,
    //     packageExpiryDate: moment(user.packageExpiryDate).format(
    //       'DD/MM/YYY - HH:mm',
    //     ),
    //   });

    const options = {};

    if (captchaProvider === CAPTCHA_PROVIDER.RECAPTCHA) {
      let recaptchaToken;
      const recaptchaTtsType = growthbook.getFeatureValue(
        FEATURE_KEYS.RECAPTCHA_TTS_TYPE,
      );
      switch (recaptchaTtsType) {
        case RECAPTCHA_TYPE.V3:
          if (executeRecaptcha) {
            recaptchaToken = await executeRecaptcha(RECAPTCHA_ACTION.SYNTHESIS);
          }
          break;
        case RECAPTCHA_TYPE.ENTERPRISE:
          if (window.grecaptcha) {
            recaptchaToken = await window?.grecaptcha?.enterprise?.execute(
              RECAPTCHA_ENTERPRISE_SITE_KEY,
            );
          }
          break;
        default:
          break;
      }
      if (recaptchaToken) options.recaptchaToken = recaptchaToken;
    }

    if (isUsingTurnstile) {
      options.turnstileToken = await turnstileWidgetRef.current.onVerify();
      turnstileWidgetRef.current.reset();
    }

    synthesisPayload.clientPause = synthesisRequest.clientPause;

    if (aiPronunciationCheckEnabled) {
      const nswPayload = getNswPayloadFromContent(content.getCurrentContent());
      if (nswPayload.length > 0) {
        synthesisPayload.nsw = nswPayload;
      }
    }

    const data = await apis.synthesis.createSynthesis(
      synthesisPayload,
      options,
    );

    const { bitrate: bitrateResponse } = data.result || {};

    const newSynthesisRequest = {
      ...data.result,
      bitrate:
        bitrateResponse % 1000 === 0 ? bitrateResponse / 1000 : bitrateResponse,
      id: data.result?.requestId,
    };

    if (hasEmphasis) {
      newSynthesisRequest.hasEmphasis = true;
      newSynthesisRequest.emphasis = data.result?.emphasisIntensity;
    }

    const hasSentences = data?.result?.sentences?.length > 0;
    const hasNoSentences = !hasSentences;

    const updateData = {
      title: newSynthesisRequest?.title || '',
      audioType: newSynthesisRequest.audioType,
      clientPause: newSynthesisRequest.clientPause || {},
      bitrate: newSynthesisRequest.bitrate,
      pronunciationDict: newSynthesisRequest.pronunciationDict || [],
      openSentences: hasSentences,
    };

    if (synthesisRequest.backgroundMusic?.link) {
      const {
        link,
        name,
        volume: currentVolume,
      } = synthesisRequest.backgroundMusic ?? {};
      updateData.backgroundMusic = { link, name, volume: currentVolume };
    }

    if (hasNoSentences) {
      updateData.voice = newSynthesisRequest.voice?.name;
      updateData.text = newSynthesisRequest.text || '';
      updateData.speed = newSynthesisRequest.speed;
    }
    if (hasSentences && data?.result?.sentences) {
      updateData.sentences = data.result.sentences.map((sentence) => ({
        breakTime: sentence?.breakTime,
        characters: sentence?.text?.length,
        speed: sentence?.speed,
        text: sentence?.text,
        voice_code: sentence.voiceCode,
      }));
    }
    dispatch(actions.synthesisRequest.updateDataRelatedRequest(updateData));
    dispatch(
      actions.synthesisRequest.updateSynthesisConfig(newSynthesisRequest, true),
    );
    handleEnableEditor(false);
    setFlickerBackground(true);
    setLoading(false);
    if (data?.status) {
      handleChangeRequestLoading(true);
      const requestId = data.result?.requestId;
      registerRequestMeta(requestId, { module: MOE_MODULE.TTS, voice });
      if (!openSentences)
        trackTryVoice({ voice, action: TRY_VOICE_ACTION.CONVERT });
      if (enableVoiceTrial && trialUsageCandidates?.length) {
        // Store mapping for rollback in case of failure
        if (requestId) {
          dispatch(
            actions.synthesisRequest.setSynthesizingVoice(
              requestId,
              trialUsageCandidates,
            ),
          );
        }
        const updatedTrialUsage = buildUpdatedTrialUsage({
          currentUsage: stateTrialVoiceUsage,
          voices: trialUsageCandidates,
          config: voiceTrialConfig,
          userFeatures: ttsUser?.features,
        });
        if (updatedTrialUsage) {
          dispatch(actions.user.updateTrialVoiceUsage(updatedTrialUsage));
        }
      }
      // document.getElementById('requests').scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'end',
      //   inline: 'nearest',
      // });
      const isNotifyLowCredits = checkShouldNotifyLowCredits({
        beforeCredits: totalCredits,
        afterCredits: totalCredits - countCredits,
        packageCode: user.packageCode,
      });
      if (isNotifyLowCredits) setNotifyLowCreditsDialog(true);
    } else {
      const { errorMessage, errorCode } = data;
      switch (errorCode) {
        case ERROR_CODE.INVALID_SYNTAX: {
          setOpenWrongSyntaxDialog({
            name: 'error-syntax',
            variant: 'warning',
            title: t('errorSyntax'),
            description: t('errorSyntaxDescription'),
          });
          break;
        }

        case ERROR_CODE.SPAM_ACCOUNT:
        case ERROR_CODE.EXCEED_RATE_LIMIT: {
          setOpenWrongSyntaxDialogV2({
            name: 'error-syntax',
            variant: 'warning',
            title: t('cannotConvertTTS'),
            description: t('blockSpamEmailDesc'),
            type: DIALOG_V2_TYPE.BLOCK_SYNTHESIS,
          });
          break;
        }

        case ERROR_CODE.INACTIVE_VOICE: {
          // Get list of inactive voices
          let inactiveVoices = [];
          if (openSentences) {
            inactiveVoices = sentences
              .filter((sentence) => sentence.voice?.active === false)
              .map((sentence) => sentence.voice?.name)
              .filter(Boolean);
          } else if (voice?.name) {
            inactiveVoices = [voice.name];
          }

          // Format voice names as HTML list
          const voiceNamesList = inactiveVoices
            .map((name) => `<li><b>${name}</b></li>`)
            .join('');

          dispatch(
            actions.dialog.displayDialogV2({
              notificationDialogV2: {
                name: 'voice-cloning-discard-info',
                title: t('unavailableVoiceV2'),
                description: t('inactiveVoiceNotiV2', {
                  voiceNames: voiceNamesList,
                }),
                open: true,
                actionComponent: renderButtonUnderstandV2(),
                showIcon: false,
                onClose: handleCloseNotificationDialogV2,
                variant: null,
                maxWidth: '640px',
                padding: '12px 24px',
                paddingHeader: '8px 24px',
                widthContent: '640px',
              },
            }),
          );
          break;
        }

        case ERROR_CODE.DISCARDED_VOICE_CLONING: {
          dispatch(
            actions.dialog.displayDialogV2({
              notificationDialogV2: {
                name: 'voice-cloning-discard-info',
                title: t('unavailableVoice'),
                description: t('discardedVoiceCloning', {
                  style: 'margin-left: -16px',
                }),
                open: true,
                actionComponent: renderButtonUnderstand(),
                showIcon: false,
                onClose: handleCloseNotificationDialogV2,
                variant: null,
              },
            }),
          );
          break;
        }

        case ERROR_CODE.NO_MORE_SUPPORT_VOICE: {
          const userEOLDate = user?.studio?.oneTime?.eolDate;

          const voiceName = openSentences
            ? [
                ...new Set(
                  synthesisSentences
                    .filter((sentence) => {
                      const voiceEOLDate = sentence?.voice?.eolDate;
                      if (!voiceEOLDate || !userEOLDate) return true;

                      const latestEOLDate = new Date(
                        Math.max(
                          new Date(voiceEOLDate).getTime(),
                          new Date(userEOLDate).getTime(),
                        ),
                      );

                      return moment().isAfter(latestEOLDate);
                    })
                    .map((sentence) => sentence.voice?.name)
                    .filter(Boolean),
                ),
              ].join(', ')
            : voice?.name;

          dispatch(
            actions.noti.push({
              severity: 'error',
              message: t('inactiveVoiceNoti', { voiceName }),
              value: errorMessage,
            }),
          );
          break;
        }

        case ERROR_CODE.TEXT_TOO_LONG: {
          trackTtsPaywall(MOE_PAYWALL_TYPE.OUT_OF_CREDITS, {
            trigger: MOE_PAYWALL_TRIGGER.SERVER_ERROR,
          });
          setOpenOutOfCreditsDialog(true);
          break;
        }

        case ERROR_CODE.LIMIT_FREE_INSTANT_VOICE_SYNTHESIS: {
          // TODO: Pass max instant synthesis to dialog
          dispatch(
            actions.limitedFeaturesDialog.showLimitedFeaturesDialog({
              description: t('unlockUnlimitedInstantVoiceSynthesis'),
              img: CrownImg,
              classNameImg: 'custom-img',
              maxWidth: 'sm',
            }),
          );
          break;
        }

        case ERROR_CODE.VOICE_TRIAL_LIMIT_REACHED: {
          // Refresh trial voice usage from API and update Redux
          if (openSentences) {
            // For sentences mode: fetch latest trial usage and find all exceeded voices
            const response = await apis.user.getTrialVoiceUsage();
            const latestTrialUsage =
              response?.result?.voiceUsage || stateTrialVoiceUsage;
            dispatch(actions.user.updateTrialVoiceUsage(latestTrialUsage));
            const errorSynthesisSentences = getSynthesisSentences();
            const voiceCreditsMapWithTimes = calculateVoiceCreditsMapWithTimes(
              errorSynthesisSentences,
            );

            // Use latest trial usage to find exceeded voices
            const exceededVoices = findExceededTrialVoices(
              voiceCreditsMapWithTimes,
              voiceTrialConfig,
              latestTrialUsage,
              ttsUser?.features,
              checkFeaturePermission,
            );

            if (exceededVoices.length > 0) {
              const exceededVoiceObjects = exceededVoices.map(
                (item) => item.voice,
              );
              handleOpenVoiceTrialLimitDialog(exceededVoiceObjects);
            } else {
              dispatch(
                actions.noti.push({
                  severity: 'error',
                  message:
                    errorCode === ERROR_CODE.BAD_REQUEST
                      ? 'errorOccurred'
                      : 'synthesisFailure',
                  value: errorMessage,
                }),
              );
            }
          } else {
            // Single voice mode: show dialog with current voice
            handleOpenVoiceTrialLimitDialog(voice);
          }
          break;
        }
        case ERROR_CODE.BACKGROUND_MUSIC_INVALID: {
          dispatch(
            actions.noti.push({
              severity: 'error',
              message: 'backgroundMusicInvalid',
            }),
          );
          break;
        }

        default: {
          dispatch(
            actions.noti.push({
              severity: 'error',
              message:
                errorCode === ERROR_CODE.BAD_REQUEST
                  ? 'errorOccurred'
                  : 'synthesisFailure',
              value: errorMessage,
            }),
          );
        }
      }
    }
  };

  const handleConfirmNonVbeeDialog = async () => {
    setTriggerBtn(true);
    setOpenWrongSyntaxDialogV2(null);
  };

  const handleClickCharsFactorCheckbox = () => {
    if (!charsFactorCheckbox) {
      localStorage.setItem('nonVbeeDialog', true);
      localStorage.setItem('charsFactorDialog', true);
    } else {
      localStorage.removeItem('nonVbeeDialog');
      localStorage.removeItem('charsFactorDialog');
    }
    setCharsFactorCheckbox((value) => !value);
  };

  const handleCreateSynthesis = async (isDefaultText) => {
    if (isDefaultText) return;

    if (isSameToday(user?.createdAt))
      setTimeout(
        () =>
          dispatch(
            actions.banner.updateDisplayBanner(
              BANNER_TYPE.FIRST_BUY_PACKAGE_TRIAL,
              true,
            ),
          ),
        POPUP_TIME_OUT,
      );

    if (!checkValidCreateSynthesis()) return;
    await createSynthesisRequest();
  };

  const fetchVoicesByViLanguage = async () => {
    const data = await apis.voices.getVoicesV3({
      voiceOwnership: VOICE_OWNERSHIP.VBEE,
      limit: 1,
      languageCode: LANGUAGE_CODE.VIETNAMESE,
    });
    if (data.result) {
      const vietnameseVoices = data.result.voices;

      if (vietnameseVoices.length) {
        // setVoice(vietnameseVoices[0]);
        dispatch(actions.synthesisRequest.updateVoice(vietnameseVoices[0]));
        handleUpdateSynthesisRequestEmphasis(vietnameseVoices[0]);
      }
    }
  };

  const fetchVoicesByEnglishLanguage = async () => {
    const data = await apis.voices.getVoicesV3({
      languageCode: ENGLISH_VOICE_CODES.toString(),
      voiceOwnership: VOICE_OWNERSHIP.VBEE,
      limit: 1,
    });
    if (data.result) {
      const englishVoices = data.result.voices;
      if (englishVoices.length) {
        // setVoice(englishVoices[0]);
        dispatch(actions.synthesisRequest.updateVoice(englishVoices[0]));
        dispatch(actions.voice.setDefaultGlobalVoice(englishVoices[0].code));
      }
    }
  };

  const fetchBlackWords = async () => {
    const data = await apis.blackWords.getBlackWords();
    if (data.result) {
      const blackWordsData = data.result.blackWords;
      setBlackWords(
        blackWordsData.map((blackWord) => blackWord.word?.toLowerCase()),
      );
    }
  };

  useEffect(() => {
    if (advanceFeature && !openSentences)
      setContent(EditorState.createEmpty(Decorator));
  }, [advanceFeature]);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < MOBILE_BREAKPOINT) {
        history.push({
          pathname: ROUTES.MOBILE_TTS,
          search: location.search,
          hash: location.hash,
        });
      }
    };
    handleResize();
  }, []);

  useEffect(() => {
    let flickerTimeout;
    if (flickerBackground) {
      flickerTimeout = setTimeout(() => setFlickerBackground(false), 3000);
    }

    return () => clearTimeout(flickerTimeout);
  }, [flickerBackground]);

  const getVoiceExist = async (code, voiceOwnership) => {
    if (!code) return null;
    const voiceExist = await apis.voices.getVoicesV2({ code, voiceOwnership });
    if (!voiceExist.status) return null;
    return voiceExist?.result?.voices[0];
  };

  const handleDeleteVoiceCode = () => {
    if (queryParams.has(VOICE_CODE)) {
      if (queryParams.has(SHOW_VOICES)) {
        queryParams.delete(SHOW_VOICES);
      }
      queryParams.delete(VOICE_CODE);
      history.replace({
        pathname: location.pathname,
        search: queryParams.toString(),
      });
    }
  };

  const getVoiceIfExists = async () => {
    const ownershipTypes = [
      VOICE_OWNERSHIP.VBEE,
      VOICE_OWNERSHIP.PERSONAL,
      VOICE_OWNERSHIP.COMMUNITY,
    ];
    const voicePromises = ownershipTypes.map((ownership) =>
      getVoiceExist(voiceCode, ownership),
    );

    const voices = await Promise.all(voicePromises);

    const existingVoice = voices?.find((item) => item);
    return existingVoice;
  };

  const getVoiceDefault = async () => {
    const isVietNam = checkVietNam();
    const isUseFreePackage = user.packageCode === PACKAGE_CODE.STUDIO_FREE;

    const isCloningVoice = isClonedVoiceCode(voice?.code);
    let voiceOwnership;
    if (isCloningVoice) {
      voiceOwnership =
        voice?.status === VOICE_STATUS.USING ||
        voice?.status === VOICE_STATUS.PRIVATE
          ? VOICE_OWNERSHIP.PERSONAL
          : VOICE_OWNERSHIP.COMMUNITY;
      dispatch(
        actions.voice.changeFilterVoice({ voiceOwnership, ...filterVoice }),
      );
    }

    if (voiceCode) {
      const existingVoice = await getVoiceIfExists();
      if (existingVoice) {
        dispatch(actions.synthesisRequest.updateVoice(existingVoice));
        handleUpdateSynthesisRequestEmphasis(existingVoice);
        if (!showVoice) handleDeleteVoiceCode();
        return;
      }
    }

    const voiceExist = await getVoiceExist(voice?.code, voiceOwnership);
    if (voiceExist) {
      dispatch(actions.synthesisRequest.updateVoice(voiceExist));
      handleUpdateSynthesisRequestEmphasis(voiceExist);
    } else if (isVietNam || isUseFreePackage) fetchVoicesByViLanguage();
    else fetchVoicesByEnglishLanguage();
  };

  const initDefaultTTSState = () => {
    getVoiceDefault();
    dispatch(
      actions.synthesisRequest.updateSynthesisConfig(DEFAULT_SYNTHESIS_REQUEST),
    );
    dispatch(actions.synthesisRequest.updateCurrentTTSPreset(null));
  };

  useEffect(() => {
    const initTTSPage = async () => {
      if (urlRequestId) {
        setOpenDraft(false);
        dispatch(actions.layout.openHighlightWeekDialog(false));
        dispatch(actions.synthesisRequest.updateLoadingLoadRequest(true));
        try {
          const data = await apis.requests.getRequestV2(urlRequestId);
          if (!data?.status) {
            throw new Error(data?.message || 'Request not found');
          }

          const synthesisConfig = data.result;

          const bitrateOfBps = synthesisConfig.bitrate || 0;
          const normalizedBitrate =
            bitrateOfBps % 1000 === 0 ? bitrateOfBps / 1000 : bitrateOfBps;

          synthesisConfig.bitrate = normalizedBitrate;

          handleEnableEditor(false);
          dispatch(
            actions.synthesisRequest.updateLoadingSynthesisConfig(false),
          );
          dispatch(
            actions.synthesisRequest.updateSynthesisConfig(synthesisConfig),
          );
          dispatch(actions.synthesisRequest.updateLoadingSynthesisConfig(true));
          dispatch(actions.synthesisRequest.updateVoice(synthesisConfig.voice));
          dispatch(
            actions.request.addSynthesisResponse({
              requestId: synthesisConfig.id,
              audioLink: synthesisConfig.audioLink,
              status: synthesisConfig.status,
              progress: synthesisConfig.progress,
              processingAt: synthesisConfig.processingAt,
              endedAt: synthesisConfig.endedAt,
            }),
          );
          dispatch(
            actions.synthesisRequest.updateSynthesisConfig(synthesisConfig),
          );
          dispatch(actions.synthesisRequest.updateCurrentTTSPreset(null));
          dispatch(actions.synthesisRequest.updateShowSampleScripts(false));
          const isVoiceCloning = isClonedVoiceCode(synthesisConfig.voice?.code);

          let voiceOwnership;
          if (isVoiceCloning) {
            voiceOwnership =
              synthesisConfig.voice?.status === VOICE_STATUS.USING ||
              synthesisConfig.voice?.status === VOICE_STATUS.PRIVATE
                ? VOICE_OWNERSHIP.PERSONAL
                : VOICE_OWNERSHIP.COMMUNITY;
          } else voiceOwnership = VOICE_OWNERSHIP.VBEE;
          dispatch(
            actions.voice.changeFilterVoice({ voiceOwnership, ...filterVoice }),
          );

          const relatedRequestData = {
            title: synthesisConfig.title,
            audioType: synthesisConfig.audioType,
            clientPause: synthesisConfig.clientPause,
            bitrate: synthesisConfig.bitrate,
            pronunciationDict: synthesisConfig.pronunciationDict,
            openSentences: synthesisConfig.openSentences || false,
            voice: synthesisConfig.voice?.name,
            text: synthesisConfig.text,
            speed: synthesisConfig.speed,
          };

          dispatch(
            actions.synthesisRequest.updateDataRelatedRequest(
              relatedRequestData,
            ),
          );

          const { createdAt, retentionPeriod = MAX_AUDIO_RETENTION_PERIOD } =
            synthesisConfig;
          const audioExpired = moment().isAfter(
            moment(createdAt).add(retentionPeriod, 'days'),
          );

          if (synthesisConfig.audioLink && !audioExpired) {
            dispatch(
              actions.audioPlayer.updateAudioLink(synthesisConfig.audioLink),
            );
            dispatch(
              actions.audioPlayer.updateSelectedAudioRequest(
                synthesisConfig.id,
              ),
            );
            dispatch(
              actions.audioPlayer.updatePreviewRequestInfo({
                ...synthesisConfig,
                id: synthesisConfig.id,
                audioLink: synthesisConfig.audioLink,
              }),
            );
          }
          return;
        } catch (error) {
          initDefaultTTSState();
        } finally {
          dispatch(actions.synthesisRequest.updateLoadingLoadRequest(false));
        }
        return;
      }

      initDefaultTTSState();
    };

    initTTSPage();
  }, [urlRequestId]);

  useEffect(() => {
    const isOpenVoices = showVoice && voiceCode && voice?.code;
    if (isOpenVoices) {
      handleOpenVoices(true);
    }
  }, [showVoice, voiceCode, voice?.code]);

  useEffect(() => {
    currentIsPlayingAudio.current = isPlaying;
  }, [isPlaying]);

  useEffect(() => {
    currentReqPreviewId.current = requestPreviewId;
  }, [requestPreviewId]);

  useEffect(() => {
    runStreamAudioRef.current = isRunStreamAudio;
  }, [isRunStreamAudio]);

  // An outcome can reach the store before this editor learns its request id,
  // and the global handler drops what it cannot match. Replaying what the
  // store already knows covers that gap, and every later correction too.
  useEffect(() => {
    if (!synthesisRequest?.id || !requestOutcome) return;
    dispatch(
      actions.synthesisRequest.applySynthesisOutcome({
        ...requestOutcome,
        requestId: synthesisRequest.id,
      }),
    );
  }, [synthesisRequest?.id, requestOutcome]);

  const connectGetRemainingPreviewWS = () => {
    ws.current = new WebSocket(TTS_SYNTHESIS_URL);
    let pingInterval;
    ws.current.onopen = () => {
      ws.current.send(
        JSON.stringify({
          type: WS_TYPE.INIT,
          accessToken: keycloak?.token,
        }),
      );
      pingInterval = setInterval(() => {
        ws.current.send(JSON.stringify({ type: WS_TYPE.PING }));
      }, PING_INTERVAL);
    };

    ws.current.onmessage = (res) => {
      const responseData = camelcaseKeys(JSON.parse(res.data), { deep: true });
      const {
        type,
        remainingPreview: newRemainingPreview,
        usedFreePreviews: numberUsedFreePreviews = 0,
      } = responseData;

      if (type === WS_TYPE.INIT)
        ws.current.send(
          JSON.stringify({ type: WS_TYPE.GET_REMAINING_PREVIEW }),
        );

      if (type === WS_TYPE.GET_REMAINING_PREVIEW) {
        setRemainingPreview(newRemainingPreview);
        setUsedFreePreviews(numberUsedFreePreviews);
      }
    };

    ws.current.onclose = (event) => {
      const { code, reason, wasClean } = event;
      // eslint-disable-next-line no-console
      console.log('Websocket is closed.', { event, code, reason, wasClean });
      clearInterval(pingInterval);
    };
  };

  const getCaptchaTokens = async () => {
    const tokens = {};
    if (captchaProvider === CAPTCHA_PROVIDER.RECAPTCHA) {
      const recaptchaTryListeningTtsType = growthbook.getFeatureValue(
        FEATURE_KEYS.RECAPTCHA_TRY_LISTEN_TTS_TYPE,
      );
      switch (recaptchaTryListeningTtsType) {
        case RECAPTCHA_TYPE.V3:
          if (executeRecaptcha)
            tokens.recaptchaToken = await executeRecaptcha(
              RECAPTCHA_ACTION.SYNTHESIS,
            );
          break;
        case RECAPTCHA_TYPE.ENTERPRISE:
          if (window.grecaptcha) {
            tokens.recaptchaToken =
              await window?.grecaptcha?.enterprise?.execute(
                RECAPTCHA_ENTERPRISE_SITE_KEY,
              );
          }
          break;
        default:
          break;
      }
    }
    if (isUsingTurnstile) {
      tokens.turnstileToken =
        await turnstileWidgetForDemoRequestRef.current.onVerify();
      turnstileWidgetForDemoRequestRef.current.reset();
    }
    return tokens;
  };

  const handlePreviewError = (errorCode) => {
    switch (errorCode) {
      case ERROR_CODE.EXCEED_RATE_LIMIT:
      case ERROR_CODE.SPAM_ACCOUNT:
        setOpenWrongSyntaxDialogV2({
          name: 'error-syntax',
          variant: 'warning',
          title: t('unavailablePreview'),
          description: t('blockSpamPreviewDesc'),
          type: DIALOG_V2_TYPE.SPAM_PREVIEW,
        });
        break;
      case ERROR_CODE.BACKGROUND_MUSIC_INVALID: {
        dispatch(
          actions.noti.push({
            severity: 'error',
            message: 'backgroundMusicInvalid',
          }),
        );
        break;
      }
      default:
        dispatch(
          actions.noti.push({
            severity: 'error',
            message: 'listeningError',
          }),
        );
        break;
    }
  };

  const connectSynthesisWS = async () => {
    const { recaptchaToken, turnstileToken } = await getCaptchaTokens();

    ws.current = new WebSocket(TTS_SYNTHESIS_URL);
    let pingInterval;
    ws.current.onopen = () => {
      ws.current.send(
        JSON.stringify({
          type: WS_TYPE.INIT,
          accessToken: keycloak?.token,
        }),
      );
      pingInterval = setInterval(() => {
        ws.current.send(JSON.stringify({ type: WS_TYPE.PING }));
      }, PING_INTERVAL);
    };

    const handleTryListeningError = (errorCode) => {
      const failurePayload = { sentenceId: '', isAudioLoading: false };
      dispatch(actions.audioPlayer.updateTryListeningSentence(failurePayload));
      handlePreviewError(errorCode);
      dispatch(actions.audioPlayer.updateRequestPreviewId(''));
    };

    ws.current.onmessage = (res) => {
      const responseData = camelcaseKeys(JSON.parse(res.data), { deep: true });
      const {
        type,
        result,
        status,
        remainingPreview: newRemainingPreview,
        usedFreePreviews: numberUsedFreePreviews = 0,
        code: errorCode,
      } = responseData;

      if (status === 0) handleTryListeningError(errorCode);
      if (type === WS_TYPE.INIT) {
        ws.current.send(
          JSON.stringify({
            type: WS_TYPE.SYNTHESIS,
            payload: previewPayload,
            accessToken: keycloak?.token,
            recaptchaToken,
            turnstileToken,
          }),
        );
      }
      if (type === WS_TYPE.SYNTHESIS) {
        switch (result && result.status) {
          case REQUEST_STATUS.IN_PROGRESS: {
            dispatch(
              actions.audioPlayer.updateRequestPreviewId(result.requestId),
            );
            break;
          }
          case REQUEST_STATUS.SUCCESS: {
            const getPublicAudioLink = async (requestId) => {
              const presignedAudioUrlResponse =
                await apis.requests.getPresignedAudioUrl(requestId);

              if (presignedAudioUrlResponse.status) {
                return presignedAudioUrlResponse.result.audio;
              }

              return null;
            };

            const playTryListeningAudio = async () => {
              ws.current.send(
                JSON.stringify({ type: WS_TYPE.GET_REMAINING_PREVIEW }),
              );
              if (currentReqPreviewId.current !== result.requestId) return;

              trackEvent(MOE_EVENTS.STUDIO_PREVIEW_TTS, {
                voice_code: previewPayload?.voiceCode,
                characters: previewPayload?.text?.length || 0,
                speed: previewPayload?.speed,
                is_streaming: !!runStreamAudioRef.current,
              });

              if (
                runStreamAudioRef.current &&
                checkFeaturePermission(
                  ttsUser.features,
                  FEATURE.STREAMING_PREVIEW,
                )
              ) {
                dispatch(
                  actions.audioPlayer.updateSelectedAudioRequest(
                    result?.requestId,
                  ),
                );
                dispatch(
                  actions.audioPlayer.updateFinalStreamAudio(result?.audioLink),
                );
                return;
              }

              if (
                currentIsPlayingAudio.current &&
                playAudioType === PLAYING_AUDIO_TYPE.SYNTHESIS
              ) {
                const cancelPayload = { sentenceId: '', isAudioLoading: false };
                dispatch(
                  actions.audioPlayer.updateTryListeningSentence(cancelPayload),
                );
              } else {
                const publicAudioLink = await getPublicAudioLink(
                  result?.requestId,
                );
                const audioLink = publicAudioLink || result?.audioLink;

                if (!showAudioPlayer)
                  dispatch(actions.audioPlayer.updateShowAudioPlayer(true));
                dispatch(actions.audioPlayer.updateAudioLink(audioLink, true));
                dispatch(actions.audioPlayer.updateSelectedAudioRequest(''));
                dispatch(
                  actions.audioPlayer.updateAudioType(
                    PLAYING_AUDIO_TYPE.SYNTHESIS,
                  ),
                );
                dispatch(
                  actions.audioPlayer.updateTryListeningSentence({ audioLink }),
                );
                dispatch(actions.audioPlayer.updateStatus(true));
              }
              dispatch(actions.audioPlayer.updateRequestPreviewId(''));
            };

            playTryListeningAudio();
            break;
          }
          case REQUEST_STATUS.FAILURE: {
            handleTryListeningError(errorCode);
            break;
          }
          default:
            break;
        }
      }

      if (type === WS_TYPE.STREAM_REQUEST) {
        if (currentReqPreviewId.current !== result.requestId) return;
        if (
          currentIsPlayingAudio.current &&
          playAudioType === PLAYING_AUDIO_TYPE.SYNTHESIS
        ) {
          const cancelPayload = { sentenceId: '', isAudioLoading: false };
          dispatch(
            actions.audioPlayer.updateTryListeningSentence(cancelPayload),
          );
          return;
        }

        if (
          checkFeaturePermission(ttsUser.features, FEATURE.STREAMING_PREVIEW) &&
          isUseStreamingPreview
        ) {
          const { index, subIndex, audioLink, phrases, tts } = result;
          if (index !== undefined) {
            dispatch(
              actions.audioPlayer.updateStreamAudios({
                index,
                subIndex,
                audioLink,
                phrases,
                tts,
              }),
            );
          }
          if (index === 0 && subIndex === 0) {
            dispatch(actions.audioPlayer.updateStatusStreamAudio(true));
            dispatch(
              actions.audioPlayer.updateTryListeningSentence({
                isAudioLoading: false,
              }),
            );
            if (!showAudioPlayer)
              dispatch(actions.audioPlayer.updateShowAudioPlayer(true));
          }
        }
      }

      if (type === WS_TYPE.GET_REMAINING_PREVIEW) {
        setUsedFreePreviews(numberUsedFreePreviews);
        setRemainingPreview(newRemainingPreview);
      }
    };

    ws.current.onclose = (event) => {
      const { code, reason, wasClean } = event;
      // eslint-disable-next-line no-console
      console.log('Websocket is closed', { code, reason, wasClean });
      clearInterval(pingInterval);
    };
  };

  // Show dialog block download cause user already download
  const { showBlockDownloadDialog } = useSelector((state) => state.user);
  useEffect(() => {
    if (showBlockDownloadDialog) {
      setActionDialog({
        image: UpgradeImg,
        title: t('unableToDownload'),
        description: t('unableToDownloadDescription', { numberDownload: 1 }),
        onClose: () => {
          dispatch(actions.user.updateShowBlockDownloadDialog(false));
          handleCloseActionDialog();
        },
        actionComponents: renderUpgradeButton(),
      });
    }
  }, [showBlockDownloadDialog]);

  useEffect(() => {
    connectGetRemainingPreviewWS();
  }, []);

  useEffect(() => {
    if (isAudioLoading) {
      ws?.current?.close();
      connectSynthesisWS();
    }
  }, [isAudioLoading]);

  useEffect(() => {
    fetchBlackWords();
  }, []);

  const handleClickBuyPackages = () => {
    history.push(ROUTES.PAYMENT);
  };

  const renderCloseButton = (handleClose) => (
    <Button variant="contained" onClick={handleClose}>
      {t('understood')}
    </Button>
  );

  const renderCloseButtonV2 = (handleClose) => {
    switch (openWrongSyntaxDialogV2?.type) {
      case DIALOG_V2_TYPE.NON_VBEE_WARNING:
        return (
          <div className="non-vbee-warning">
            <FormControlLabel
              control={
                <Checkbox
                  classes={{ root: 'checkbox' }}
                  color="iconPrimary"
                  value={charsFactorCheckbox}
                  onChange={handleClickCharsFactorCheckbox}
                />
              }
              label={
                <Typography className="not-show-again-text">
                  {t('notShowAgain')}
                </Typography>
              }
              labelPlacement={t('notShowAgain')}
            />
            <div className="">
              <Button
                className="btn-non-vbee-warning"
                variant="outlined"
                onClick={handleClose}
              >
                {t('cancel')}
              </Button>
              <Button
                className="btn-non-vbee-warning"
                variant="contained"
                onClick={handleConfirmNonVbeeDialog}
              >
                {t('continueGenerate')}
              </Button>
            </div>
          </div>
        );
      case DIALOG_V2_TYPE.CANNOT_USE_VOICE:
        return (
          <Button
            className="btn-understood"
            variant="contained"
            onClick={() => {
              setOpenWrongSyntaxDialogV2(null);
            }}
          >
            {t('gotItV2')}
          </Button>
        );
      case DIALOG_V2_TYPE.RENAME_VOICE:
        return (
          <Button
            className="btn-understood"
            variant="contained"
            onClick={() => {
              setOpenWrongSyntaxDialogV2(null);
            }}
          >
            {t('gotIt')}
          </Button>
        );
      case DIALOG_V2_TYPE.SPAM_PREVIEW:
      case DIALOG_V2_TYPE.BLOCK_SYNTHESIS:
        return (
          <Button
            className="btn-understood"
            variant="contained"
            onClick={() => {
              window.open(`${LANDING_PAGE_URL}/support`, '_blank');
            }}
          >
            {t('submitSupportRequest')}
          </Button>
        );
      default:
        return (
          <Button
            className="btn-understood"
            variant="contained"
            onClick={handleClickBuyPackages}
          >
            {t('buyPackages')}
          </Button>
        );
    }
  };

  useEffect(() => {
    const doneTourGuide = getTTSTourGuideValue(user?.id);
    const keyShowTourGuide = JSON.parse(doneTourGuide);
    // Delay to ensure the DOM is fully rendered
    setTimeout(() => {
      if (!keyShowTourGuide && seenAllBanner && hasAgreedToTerms) {
        handleChangeRunTourGuide(true);
        setTTSTourGuideValue(user?.id, true);
      }
    }, 500);
  }, [seenAllBanner, hasAgreedToTerms]);

  useEffect(() => {
    if (limitedFeature) {
      setActionDialog({
        image: UpgradeImg,
        title: t('limitedFeature'),
        description: t('limitedFeatureDescription'),
        onClose: handleCloseLimitedFeatureDialog,
        actionComponents: renderUpgradeButton(),
      });
      dispatch(actions.dialog.displayDialog({ limitedFeature: false }));
    }
  }, [limitedFeature]);

  useEffect(
    () => () => {
      dispatch(actions.audioPlayer.resetAudioPlayer());
    },
    [],
  );

  useEffect(() => {
    if (screenHeight > HEIGHT_LARGE_SCREEN) {
      setIsExpandRequest(true);
    }
  }, [screenHeight]);

  const [closeMoreMenu, setCloseMoreMenu] = useState(false);

  useEffect(() => {
    if (isOpenCommunityVoice) {
      handleOpenVoices(true);
      dispatch(
        actions.voice.changeFilterVoice({
          voiceOwnership: VOICE_OWNERSHIP.COMMUNITY,
        }),
      );
    }
  }, [hashValue]);

  const renderOutOfCreditsDialog = () => {
    const isPackageStandardV3 =
      usingPackage.level === PACKAGE_LEVEL_V3.STANDARD &&
      usingPackage?.version?.includes(PACKAGE_STUDIO_VERSION.V3);

    const isPackageSpecialV3 =
      usingPackage.level === PACKAGE_LEVEL_V3.SPECIAL &&
      usingPackage?.version?.includes(PACKAGE_STUDIO_VERSION.V3);

    const isPackageVipV3 =
      usingPackage.level === PACKAGE_LEVEL_V3.VIP &&
      usingPackage?.version?.includes(PACKAGE_STUDIO_VERSION.V3);

    const isCustomPackage = checkCustomPackage({
      type: usingPackage?.type,
      level: usingPackage.level,
    });

    if (isCustomPackage) {
      return (
        <OutOfCreditsCustom
          open={openOutOfCreditsDialog}
          onClose={handleCloseOutOfCreditsDialog}
          packageCode={packageCode}
        />
      );
    }

    if (isPackageStandardV3) {
      return (
        <OutOfCreditsStandard
          open={openOutOfCreditsDialog}
          onClose={handleCloseOutOfCreditsDialog}
          packageCode={packageCode}
          voice={voice}
        />
      );
    }

    if (isPackageSpecialV3) {
      return (
        <OutOfCreditsSpecial
          open={openOutOfCreditsDialog}
          onClose={handleCloseOutOfCreditsDialog}
          packageCode={packageCode}
          voice={voice}
        />
      );
    }

    if (isPackageVipV3)
      return (
        <OutOfCreditsVip
          open={openOutOfCreditsDialog}
          onClose={handleCloseOutOfCreditsDialog}
          warningOneTimeCredits={warningOneTimeCredits}
        />
      );

    // Display this popup when using a free package or a package that is neither standard nor special v3.
    return (
      <OutOfCreditsFree
        open={openOutOfCreditsDialog}
        onClose={handleCloseOutOfCreditsDialog}
      />
    );
  };

  const renderMaxCharsLimitExceededDialog = () => {
    const isFreePackage = FREE_PACKAGE_CODES.includes(packageCode);

    if (isFreePackage) {
      return (
        <FreeMaxCharsLimitExceeded
          open={openMaxCharsLimitExceeded}
          onClose={handleCloseMaxCharsLimitExceededDialog}
          maxLengthInputText={maxLengthInputText}
        />
      );
    }

    return (
      <PaidMaxCharsLimitExceeded
        open={openMaxCharsLimitExceeded}
        onClose={handleCloseMaxCharsLimitExceededDialog}
        maxLengthInputText={maxLengthInputText}
      />
    );
  };

  return (
    <>
      <StyledTTS ref={TTSRef} showaudioplayer={showAudioPlayer}>
        <TitleBarNew
          loading={loading}
          characterExceed={characterExceed}
          inputLength={inputLength}
          isLoadDraft={loadDraft}
          onLoadEditContent={handleLoadContentEditor}
          onChangeInputLength={handleChangeInputLength}
          onOpenConfirmDialog={handleOpenDraft}
          content={content}
          enableEditor={enableEditor}
          onChangeRequestLoading={handleChangeRequestLoading}
          onEnableEditor={handleEnableEditor}
        />

        <div style={{ position: 'relative' }}>
          {pronunciationCheck.isLoading && (
            <AILoadingOverlay text={t('aiProcessing')} />
          )}
          {/* Point to get Element scroll to top of the page */}
          <div id="scroll-point-top" className="scroll-point-top" />
          {!isNewHomepage && (
            <div ref={ttsRef} className="tts" id="request-editor">
              {loadingLoadRequest && (
                <div className="blur-tts">
                  <CircularProgress
                    value={75}
                    className="loading-load-request"
                    size="24px"
                  />
                </div>
              )}
              <PronunciationCheckContext.Provider
                value={{
                  ...pronunciationCheck,
                  getCaptchaTokens,
                  handlePreviewError,
                }}
              >
                <Card flexDirection="column" padding="16px" position="relative">
                  <ToolbarV3
                    content={content}
                    openSentences={openSentences}
                    toolbarRef={toolbarRef}
                    isSSML={isSSML}
                    useNewTtsUI
                    onOpenVoice={handleOpenVoices}
                    handleChangeIsSSML={handleChangeIsSSML}
                    handleChangeContent={handleChangeContent}
                    onChangeInputLength={handleChangeInputLength}
                    onChangeCharacterExceed={handleChangeCharacterExceed}
                    onOpenSentences={handleOpenSentences}
                    synthesisSentence={synthesisSentence}
                    onTryListeningSentence={checkConditionPackageToPreview}
                    audioRef={audioRef}
                    enableEditor={enableEditor}
                    onEnableEditor={handleEnableEditor}
                    closeMoreMenu={closeMoreMenu}
                    setCloseMoreMenu={setCloseMoreMenu}
                    handleChangeVoice={handleChangeVoice}
                  />
                  <Content
                    openSentences={openSentences}
                    content={content}
                    isSmallContent={isExpandRequest}
                    inputLength={inputLength}
                    toolbarRef={toolbarRef}
                    characterExceed={characterExceed}
                    requestTableHeight={requestTableHeight}
                    onChangeContent={handleChangeContent}
                    onChangeInputLength={handleChangeInputLength}
                    onChangeCharacterExceed={handleChangeCharacterExceed}
                    onchangeSynthesisSentence={handleChangeSynthesisSentence}
                    onTryListeningSentence={checkConditionPackageToPreview}
                    onChangeVoice={handleChangeVoice}
                    audioRef={audioRef}
                    synthesisSentence={synthesisSentence}
                    enableEditor={enableEditor}
                    onEnableEditor={handleEnableEditor}
                    onResetContentEditor={handleResetContentEditor}
                    onChangeExpandRequestTable={handleChangeIsExpandRequest}
                  >
                    <TitleBar
                      isNewLayout={1}
                      loading={loading}
                      showWarningFactorCharcterDialog={
                        showWarningFactorCharcterDialog
                      }
                      onCreateSynthesis={handleCreateSynthesis}
                      triggerBtn={triggerBtn}
                      onCancelTriggerBtn={() => setTriggerBtn(false)}
                      characterExceed={characterExceed}
                      inputLength={inputLength}
                      isLoadDraft={loadDraft}
                      onLoadEditContent={handleLoadContentEditor}
                      onChangeInputLength={handleChangeInputLength}
                      onOpenConfirmDialog={handleOpenDraft}
                      content={content}
                      enableEditor={enableEditor}
                      onCreateNewEditor={handleCreateNewEditor}
                      audioRef={audioRef}
                      onChangeRequestLoading={handleChangeRequestLoading}
                      onEnableEditor={handleEnableEditor}
                      setCloseMoreMenu={setCloseMoreMenu}
                      showNonVbeeWarning={showNonVbeeWarning}
                      showWarningCannotUseVoiceDialog={
                        showWarningCannotUseVoiceDialog
                      }
                    />
                  </Content>
                  <VoiceSelectionDialog
                    open={openVoices}
                    activeVoiceId={voice && voice.id}
                    activeVoiceCode={voice && voice.code}
                    onClose={handleCloseVoices}
                    onChangeVoice={handleChangeVoice}
                    hasLanguageFilter
                  />
                </Card>
              </PronunciationCheckContext.Provider>
            </div>
          )}
          <div
            style={{ height: '100%' }}
            className="request"
            ref={requestTableRef}
            id="requests"
          >
            <Card
              flexDirection="column"
              margin-top="4px"
              padding={!isNewHomepage ? '4px 16px 0px 16px' : '0px'}
            >
              <NewRequest
                onClickAddRequest={onClickAddRequest}
                isNewHomepage={isNewHomepage}
                requestListHeight={useElementHeight(requestTableRef)}
                flickerBackground={flickerBackground}
                isExpand={isNewHomepage || isExpandRequest}
                requestLoading={requestLoading}
                onChangeRequestLoading={handleChangeRequestLoading}
                onChangeIsExpand={handleChangeIsExpandRequest}
                onEnableEditor={handleEnableEditor}
                audioRef={audioRef}
              />
            </Card>
          </div>
        </div>

        <ConfirmDialog
          title={t('note')}
          content={t('reloadPreviousWorkContent')}
          open={openDraft}
          onClose={handleCloseDraft}
          onConfirm={handleLoadDraft}
          confirmDataId="reload-prev-session"
          closeDataId="not-reload-prev-session"
        />

        <ConfirmDialog
          title={t('confirmSwitchProcessingMethod')}
          content={t('switchProcessingMethodNote')}
          open={confirmSwitchParagraph}
          closeDataId="cancel-unsplit-para"
          confirmDataId="confirm-unsplit-para"
          onClose={handleCloseConfirmDialog}
          onConfirm={handleAcceptConfirmDialog}
        />

        <NotificationDialog
          name="ssml"
          title={t('convertTTSBySSML')}
          description={t('inValidSSML')}
          variant="warning"
          open={openSSMLDialog}
          onClose={handleCloseSSMLDialog}
          actionComponent={renderCloseButton(handleCloseSSMLDialog)}
        />

        {runTourGuide && (
          <NewTourGuide
            stepsGuide={stepsGuide}
            run={runTourGuide}
            onChangeRunTourGuide={handleChangeRunTourGuide}
            stepDisplay={false}
          />
        )}

        <NotificationDialog
          name="break-time"
          title={t('errorSyntax')}
          description={t('errorInvalidBreakTimeDesc')}
          variant="warning"
          open={openWrongBreakTimeDialog}
          onClose={() => handleChangeOpenWrongBreakTimeDialog(false)}
          actionComponent={renderCloseButton(() =>
            handleChangeOpenWrongBreakTimeDialog(false),
          )}
        />

        <NotificationDialog
          name={openWrongSyntaxDialog?.name}
          title={openWrongSyntaxDialog?.title}
          description={openWrongSyntaxDialog?.description}
          subDescription={openWrongSyntaxDialog?.subDescription}
          variant={openWrongSyntaxDialog?.variant}
          open={!!openWrongSyntaxDialog?.title}
          onClose={() => setOpenWrongSyntaxDialog(null)}
          actionComponent={renderCloseButton(() =>
            setOpenWrongSyntaxDialog(null),
          )}
        />

        <NotificationDialogV3
          name={openWrongSyntaxDialogV2?.name}
          title={openWrongSyntaxDialogV2?.title}
          description={openWrongSyntaxDialogV2?.description}
          subDescription={openWrongSyntaxDialogV2?.subDescription}
          variant={openWrongSyntaxDialogV2?.variant}
          open={!!openWrongSyntaxDialogV2?.title}
          onClose={() => setOpenWrongSyntaxDialogV2(null)}
          actionComponent={renderCloseButtonV2(() =>
            setOpenWrongSyntaxDialogV2(null),
          )}
        />

        {!!openDialogLockedCycle?.title && (
          <NotificationDialogV4
            image={LockCycle}
            title={openDialogLockedCycle?.title}
            description={openDialogLockedCycle?.description}
            actionComponent={renderLockedCycleButton()}
            open={!!openDialogLockedCycle?.title}
            onClose={() => setOpenDialogLockedCycle(null)}
          />
        )}

        {actionDialog?.title && (
          <ActionDialog
            image={actionDialog?.image}
            open={!!actionDialog?.title}
            title={actionDialog?.title}
            description={actionDialog?.description}
            onClose={actionDialog?.onClose}
            actionComponents={actionDialog?.actionComponents}
          />
        )}

        <ExpiredPackageAlert
          open={openExpiredPackageDialog}
          onClose={handleCloseExpiredPackageDialog}
        />

        {renderMaxCharsLimitExceededDialog()}

        {renderOutOfCreditsDialog()}

        {notifyLowCreditsDialog && (
          <NotifyLowCredits
            open={notifyLowCreditsDialog}
            onClose={() => setNotifyLowCreditsDialog(false)}
            usingPackage={usingPackage}
          />
        )}

        {aiPronunciationCheckEnabled && (
          <NavigationBlocker
            when={pronunciationCheck.isLoading}
            navigate={(path) => history.push(path)}
            description={t('leaveWhileProcessingDescription')}
            onLeave={pronunciationCheck.cancelCheck}
          />
        )}
      </StyledTTS>

      <AudioPlayer audioRef={audioRef} />

      {isUsingTurnstile && (
        <>
          <TurnstileWidget ref={turnstileWidgetRef} />
          <TurnstileWidget ref={turnstileWidgetForDemoRequestRef} />
        </>
      )}
    </>
  );
};

export default TTSNew;
